(function () {
  'use strict';

  const TAB_NAMES = ['dashboard', 'drops', 'stories', 'honor', 'knife-registry', 'profile'];

  const ICONS = {
    view: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z"/><circle cx="12" cy="12" r="3"/></svg>',
    edit: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"/></svg>',
    delete: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>',
    dashboard: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 13h6V4H4v9Zm0 7h6v-5H4v5Zm10 0h6v-9h-6v9Zm0-16v5h6V4h-6Z"></path></svg>',
    stories: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4h10l4 4v12H5V4Zm9 1.8V9h3.2L14 5.8ZM8 12h8v-2H8v2Zm0 4h8v-2H8v2Zm0 3h5v-2H8v2Z"></path></svg>',
    pending: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 5h-2v6l5 3 1-1.7-4-2.3V7Z"></path></svg>',
    approved: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9.2 16.6 4.9 12.3 3.5 13.7l5.7 5.7L20.8 7.8l-1.4-1.4L9.2 16.6Z"></path></svg>',
    rejected: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm3.5 12.1-1.4 1.4L12 13.4l-2.1 2.1-1.4-1.4 2.1-2.1-2.1-2.1 1.4-1.4 2.1 2.1 2.1-2.1 1.4 1.4-2.1 2.1 2.1 2.1Z"></path></svg>',
    featured: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h12v18l-6-3-6 3V3Zm2 2v12.8l4-2 4 2V5H8Z"></path></svg>',
    honor: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2 2.9 6 6.6 1-4.8 4.6 1.1 6.5L12 17l-5.8 3.1 1.1-6.5L2.5 9l6.6-1L12 2Z"></path></svg>',
    drops: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 4h14v4H5V4Zm1 6h12l-1 10H7L6 10Zm4 2v2h4v-2h-4Z"></path></svg>',
    knifeRegistry: '<svg viewBox="0 0 24 24" aria-hidden="true"><g transform="rotate(45 12 12)"><path d="M2 10h7v4H2z"></path><path d="M9 9h1.5v6H9z"></path><path d="M10.5 9 22 12 10.5 15z"></path></g></svg>',
    external: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17 17 7"/><path d="M8 7h9v9"/></svg>'
  };

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function getYouTubeEmbedUrl(value, autoplay) {
    const rawUrl = String(value || '').trim();
    if (!rawUrl) return '';

    let url;
    try {
      url = new URL(rawUrl);
    } catch (error) {
      return '';
    }

    const host = url.hostname.toLowerCase().replace(/^www\./, '').replace(/^m\./, '');
    const segments = url.pathname.split('/').filter(Boolean);
    let videoId = '';

    if (host === 'youtu.be') {
      videoId = segments[0] || '';
    } else if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
      if (segments[0] === 'watch') {
        videoId = url.searchParams.get('v') || '';
      } else if (['embed', 'shorts', 'live'].indexOf(segments[0]) !== -1) {
        videoId = segments[1] || '';
      }
    }

    videoId = String(videoId || '').replace(/[^A-Za-z0-9_-]/g, '');
    if (!videoId) return '';

    return `https://www.youtube.com/embed/${videoId}?rel=0${autoplay ? '&autoplay=1&mute=1&playsinline=1' : ''}`;
  }

  function addResourceHint(rel, href, crossOrigin) {
    if (typeof document === 'undefined' || !document.head) return;
    if (document.head.querySelector(`link[rel="${rel}"][href="${href}"]`)) return;

    const link = document.createElement('link');
    link.rel = rel;
    link.href = href;
    if (crossOrigin) link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  }

  function warmYouTubeConnections() {
    [
      'https://www.youtube.com',
      'https://www.youtube-nocookie.com',
      'https://i.ytimg.com',
      'https://s.ytimg.com',
      'https://www.google.com'
    ].forEach((href) => {
      addResourceHint('dns-prefetch', href, false);
      addResourceHint('preconnect', href, true);
    });
  }

  function preloadYouTubeEmbed(value) {
    const embedUrl = getYouTubeEmbedUrl(value, false);
    if (!embedUrl || typeof document === 'undefined' || !document.body) return;

    warmYouTubeConnections();

    let frame = document.getElementById('tkc-youtube-embed-preload');
    if (!frame) {
      frame = document.createElement('iframe');
      frame.id = 'tkc-youtube-embed-preload';
      frame.title = 'YouTube player preload';
      frame.loading = 'eager';
      frame.tabIndex = -1;
      frame.setAttribute('aria-hidden', 'true');
      frame.style.cssText = 'position:absolute;width:1px;height:1px;left:-9999px;top:-9999px;opacity:0;pointer-events:none;border:0;';
      document.body.appendChild(frame);
    }

    if (frame.dataset.src !== embedUrl) {
      frame.dataset.src = embedUrl;
      frame.src = embedUrl;
    }
  }

  function renderVideoPlayer(url, className, autoplay) {
    const embedUrl = getYouTubeEmbedUrl(url, autoplay);

    if (embedUrl) {
      warmYouTubeConnections();
      return `<iframe class="${className}" src="${escapeHtml(embedUrl)}" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen loading="${autoplay ? 'eager' : 'lazy'}"></iframe>`;
    }

    return `<video class="${className}" ${autoplay ? 'controls autoplay muted playsinline' : 'muted preload="metadata" playsinline'} src="${escapeHtml(url)}"></video>`;
  }

  function renderVideoPreview(url, className) {
    const isYouTube = !!getYouTubeEmbedUrl(url, false);
    if (isYouTube) preloadYouTubeEmbed(url);

    const poster = isYouTube
      ? '<span class="tkc-admin__story-view-video-poster">Video</span>'
      : `<video class="tkc-admin__story-view-video-poster" muted preload="metadata" playsinline src="${escapeHtml(url)}"></video>`;

    return `
      <span class="${className} tkc-admin__story-view-video-preview">
        ${poster}
        <span class="tkc-admin__story-view-play-icon" aria-hidden="true"></span>
      </span>
    `;
  }

  function formatDate(value) {
    if (!value) return 'Not available';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
  }

  function toDateInputValue(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return typeof value === 'string' ? value.slice(0, 10) : '';
    }
    return date.toISOString().slice(0, 10);
  }

  function preventLongDateYear(input) {
    if (!input || String(input.getAttribute('type') || input.type || '').toLowerCase() !== 'date' || !input.value) return;

    const value = String(input.value);
    const isoMatch = value.match(/^([+-]?)(\d{5,})(-\d{2}-\d{2})$/);
    if (isoMatch) {
      input.value = `${isoMatch[1]}${isoMatch[2].slice(0, 4)}${isoMatch[3]}`;
      return;
    }

    const localizedMatch = value.match(/^(\d{1,2}[/-]\d{1,2}[/-])(\d{5,})$/);
    if (localizedMatch) input.value = `${localizedMatch[1]}${localizedMatch[2].slice(0, 4)}`;
  }

  function preventLongDateYears(container) {
    if (!container || !container.querySelectorAll) return;
    container.querySelectorAll('input[type="date"]').forEach(preventLongDateYear);
  }

  function normalizeStatus(status) {
    return String(status || '').toUpperCase();
  }

  function isNeedsEditsStatus(status) {
    return normalizeStatus(status) === 'NEEDS_EDITS';
  }

  function statusClass(status) {
    return String(status || 'unknown').toLowerCase().replace(/[^a-z0-9]+/g, '-');
  }

  function getFirstDefined() {
    for (let index = 0; index < arguments.length; index += 1) {
      if (arguments[index] !== null && arguments[index] !== undefined && arguments[index] !== '') {
        return arguments[index];
      }
    }

    return '';
  }

  function normalizeDropStatus(status) {
    return normalizeStatus(status || 'SCHEDULED');
  }

  function isScheduledDrop(drop) {
    return normalizeDropStatus(drop && drop.status) === 'SCHEDULED';
  }

  function isLiveDrop(drop) {
    return ['LIVE', 'LAUNCHED', 'ACTIVE'].indexOf(normalizeDropStatus(drop && drop.status)) !== -1;
  }

  function getDropCollectionId(drop) {
    return getFirstDefined(drop && drop.shopifyCollectionId, drop && drop.shopify_collection_id, drop && drop.collection_id);
  }

  function getShopifyNumericId(value) {
    const match = String(value || '').match(/(\d+)(?:\D*)$/);
    return match ? match[1] : '';
  }

  function getDropCollectionTitle(drop) {
    return getFirstDefined(drop && drop.collectionTitle, drop && drop.collection_title, drop && drop.title, 'Untitled collection');
  }

  function getDropCollectionHandle(drop) {
    return getFirstDefined(drop && drop.collectionHandle, drop && drop.collection_handle, drop && drop.handle);
  }

  function getDropProductsCount(drop) {
    return getFirstDefined(drop && drop.productsCount, drop && drop.products_count, drop && drop.productCount, drop && drop.product_count);
  }

  function getDropLaunchAt(drop) {
    return getFirstDefined(drop && drop.launchAt, drop && drop.launch_at, drop && drop.launch_at_utc);
  }

  function getDropCreatedAt(drop) {
    return getFirstDefined(drop && drop.createdAt, drop && drop.created_at);
  }

  function getDropQuantity(drop) {
    return getFirstDefined(drop && drop.quantity, drop && drop.drop_quantity);
  }

  function getDropTeaser(drop) {
    return getFirstDefined(drop && drop.teaserDescription, drop && drop.teaser_description);
  }

  function getCollectionId(collection) {
    return getFirstDefined(collection && collection.id, collection && collection.shopifyCollectionId, collection && collection.shopify_collection_id);
  }

  function getCollectionTitle(collection) {
    return getFirstDefined(collection && collection.title, collection && collection.collectionTitle, collection && collection.collection_title, 'Untitled collection');
  }

  function getCollectionHandle(collection) {
    return getFirstDefined(collection && collection.handle, collection && collection.collectionHandle, collection && collection.collection_handle);
  }

  function getCollectionProductCount(collection) {
    return getFirstDefined(collection && collection.productsCount, collection && collection.products_count, collection && collection.productCount, collection && collection.product_count);
  }

  function formatDropDateTime(value, timezone) {
    if (!value) return 'Not scheduled';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return value;

    try {
      return new Intl.DateTimeFormat(undefined, {
        timeZone: timezone || 'America/Chicago',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZoneName: 'short'
      }).format(date);
    } catch (error) {
      return date.toLocaleString();
    }
  }

  function getZonedDateTimeParts(value, timezone) {
    const date = new Date(value);
    if (!value || Number.isNaN(date.getTime())) return { date: '', time: '' };

    try {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone || 'America/Chicago',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      const parts = formatter.formatToParts(date).reduce((acc, part) => {
        acc[part.type] = part.value;
        return acc;
      }, {});
      const hour = parts.hour === '24' ? '00' : parts.hour;

      return {
        date: `${parts.year}-${parts.month}-${parts.day}`,
        time: `${hour}:${parts.minute}`
      };
    } catch (error) {
      return {
        date: date.toISOString().slice(0, 10),
        time: date.toISOString().slice(11, 16)
      };
    }
  }

  function getStoryNode(edge) {
    return edge && edge.node ? edge.node : edge;
  }

  function getConnectionItems(connection) {
    if (!connection) return [];
    if (Array.isArray(connection)) return connection.map(getStoryNode).filter(Boolean);
    if (Array.isArray(connection.edges)) return connection.edges.map(getStoryNode).filter(Boolean);
    if (Array.isArray(connection.nodes)) return connection.nodes.filter(Boolean);
    if (Array.isArray(connection.items)) return connection.items.map(getStoryNode).filter(Boolean);
    if (Array.isArray(connection.stories)) return connection.stories.map(getStoryNode).filter(Boolean);
    return [];
  }

  function getConnectionPageInfo(connection) {
    if (!connection || typeof connection !== 'object' || Array.isArray(connection)) return {};
    return connection.pageInfo || connection.page_info || {};
  }

  function hasNextStoryPage(pageInfo) {
    if (!pageInfo) return false;
    return pageInfo.hasNextPage === true ||
      pageInfo.has_next_page === true ||
      String(pageInfo.hasNextPage || pageInfo.has_next_page || '').toLowerCase() === 'true';
  }

  function getStoryEndCursor(pageInfo, items) {
    if (pageInfo && (pageInfo.endCursor || pageInfo.end_cursor)) {
      return pageInfo.endCursor || pageInfo.end_cursor;
    }

    const lastItem = items && items.length ? items[items.length - 1] : null;
    return lastItem && lastItem.cursor ? lastItem.cursor : null;
  }

  function getDigits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function getPhoneParts(form) {
    const countrySelect = form.elements.phone_country_code;
    const phoneInput = form.elements.phone_national_number;
    const countryCode = countrySelect ? String(countrySelect.value || '').trim() : '';
    const countryDigits = getDigits(countryCode);
    let nationalDigits = getDigits(phoneInput ? phoneInput.value : '');

    if (countryDigits && nationalDigits.indexOf(countryDigits) === 0) {
      nationalDigits = nationalDigits.slice(countryDigits.length);
    }

    nationalDigits = nationalDigits.replace(/^0+/, '');

    return {
      countryCode: countryDigits ? `+${countryDigits}` : '',
      countryDigits,
      nationalDigits
    };
  }

  function getNormalizedPhoneNumber(form) {
    const parts = getPhoneParts(form);
    return parts.countryCode && parts.nationalDigits ? `${parts.countryCode}${parts.nationalDigits}` : '';
  }

  function getPhoneValidationMessage(form, options) {
    const settings = Object.assign({ required: false }, options || {});
    const parts = getPhoneParts(form);
    const totalLength = `${parts.countryDigits}${parts.nationalDigits}`.length;

    if (!settings.required && !parts.nationalDigits) return '';
    if (!parts.countryCode) return 'Select a country code.';
    if (!parts.nationalDigits) return 'Enter your phone number.';
    if (parts.nationalDigits.length < 4) return 'Enter a valid phone number for the selected country.';
    if (totalLength > 15) return 'Phone number must be 15 digits or fewer including country code.';
    if (totalLength < 7) return 'Enter a valid phone number for the selected country.';

    return '';
  }

  function validatePhoneField(form, options) {
    const phoneInput = form.elements.phone_national_number;
    if (!phoneInput) return true;

    const message = getPhoneValidationMessage(form, options);
    phoneInput.setCustomValidity(message);
    return !message;
  }

  function setPhoneFieldValue(form, phoneNumber) {
    const countrySelect = form.elements.phone_country_code;
    const phoneInput = form.elements.phone_national_number;
    if (!countrySelect || !phoneInput) return;

    const digits = getDigits(phoneNumber);
    const options = Array.from(countrySelect.options)
      .filter((option) => getDigits(option.value))
      .sort((first, second) => getDigits(second.value).length - getDigits(first.value).length);
    const selected = options.find((option) => digits.indexOf(getDigits(option.value)) === 0) || countrySelect.options[0];
    const countryDigits = selected ? getDigits(selected.value) : '';

    if (selected) {
      countrySelect.value = selected.value;
    }

    phoneInput.value = countryDigits && digits.indexOf(countryDigits) === 0
      ? digits.slice(countryDigits.length)
      : digits;
    phoneInput.setCustomValidity('');
  }

  function isHallOfHonor(story) {
    return !!(story && (story.is_hall_of_honour || story.is_hall_of_honor));
  }

  function parseBooleanFilter(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    return null;
  }

  function unique(keys) {
    return keys.filter((key, index, list) => key && list.indexOf(key) === index);
  }

  function hasAdminRole(user) {
    return !!(
      user &&
      Object.prototype.hasOwnProperty.call(user, 'role') &&
      /^(admin|administrator|super_admin|superadmin)$/i.test(String(user.role || ''))
    );
  }

  function wait(ms) {
    return new Promise((resolve) => window.setTimeout(resolve, ms));
  }

  function getAuthConfig() {
    return window.TKC && window.TKC.authConfig ? window.TKC.authConfig : {};
  }

  class AdminPortal {
    constructor(root) {
      this.root = root;
      this.config = this.readConfig();
      this.api = new window.TKC.AdminPortalApi({
        endpoint: this.config.endpoint,
        tokenKey: this.config.tokenKey,
        tokenFallbackKeys: this.config.tokenFallbackKeys,
        storiesQuery: this.config.storiesQuery,
        categoriesQuery: this.config.categoriesQuery,
        dropsQuery: this.config.dropsQuery,
        dropCollectionsQuery: this.config.dropCollectionsQuery,
        createStoryMutation: this.config.createStoryMutation,
        updateStoryMutation: this.config.updateStoryMutation,
        deleteStoryMutation: this.config.deleteStoryMutation,
        createDropMutation: this.config.createDropMutation,
        updateDropMutation: this.config.updateDropMutation,
        cancelDropMutation: this.config.cancelDropMutation,
        signoutMutation: this.config.signoutMutation,
        knifeRegistrationsQuery: this.config.knifeRegistrationsQuery,
        exportKnifeRegistrationsCsvQuery: this.config.exportKnifeRegistrationsCsvQuery,
        updateKnifeRegistrationMutation: this.config.updateKnifeRegistrationMutation,
        deleteKnifeRegistrationMutation: this.config.deleteKnifeRegistrationMutation
      });
      this.activeTab = 'dashboard';
      this.loaded = {};
      this.drops = [];
      this.knifeRegistrations = [];
      this.knifeRegistrationsPageInfo = {};
      this.knifeRegistrationsPerPage = Number(this.config.knifeRegistrationsPerPage || 20) || 20;
      // Cursor-based paging: cursors[i] is the `after` value that fetches page i (0-indexed).
      // The registry is searched/filtered server-side now, so there's no full local cache to page through.
      this.knifeRegistrationsCursors = [null];
      this.knifeRegistrationsPageIndex = 0;
      this.knifeRegistrationsRequestId = 0;
      this.knifeRegistrationsSearchTimer = null;
      this.knifeRegistrationFilters = {
        search: '',
        registration_status: '',
        is_founders_run: '',
        created_after: '',
        created_before: ''
      };
      this.pendingDeleteKnifeRegistrationId = null;
      this.knifeRegistrationPhotos = { knife_photo: {}, certificate_photo: {} };
      this.knifeRegistrationPhotoPreviewUrls = {};
      this.dropCollectionSearchTimer = null;
      this.dropCollectionRequestId = 0;
      this.selectedDropCollection = null;
      this.stories = [];
      this.allStories = [];
      this.storiesPageInfo = {};
      this.storyFilters = { search: '', status: '', featured: '', honor: '' };
      this.storiesPage = 1;
      this.honorPage = 1;
      this.storiesPerPage = Number(this.config.storiesPerPage || 20) || 20;
      this.storyFetchPageSize = Number(this.config.storyFetchPageSize || 100) || 100;
      this.storyPageDelayMs = Number(this.config.storyPageDelayMs || 1500) || 1500;
      this.storyCacheMs = Number(this.config.storyCacheMs || 30000) || 30000;
      this.initialStoryLoadDelayMs = Number(this.config.initialStoryLoadDelayMs || 5000) || 5000;
      this.storiesFetchedAt = 0;
      this.storiesFetchPromise = null;
      this.userKey = this.config.userKey || 'tkcAdminUser';
      this.deviceIdKey = this.config.deviceIdKey || 'device_id';
      this.loginAtKey = this.config.loginAtKey || 'tkcAdminLoginAt';
      this.storyCacheKey = this.config.storyCacheKey || 'tkcAdminStoriesCache';
      this.storyCooldownKey = this.config.storyCooldownKey || 'tkcAdminStoriesCooldownUntil';
      this.pendingCancelDropId = null;
      this.pendingEndDropId = null;
      this.pendingDeleteStoryId = null;
      this.editingStoryId = null;
      this.editingStoryMedia = [];
      this.selectedStoryFiles = [];
      this.storyNewMediaUrls = [];
      this.storyFormMode = 'create';
      this.storyDraftStarted = false;

      if (!this.api.getToken()) {
        this.redirectToLogin();
        return;
      }

      if (!hasAdminRole(this.getStoredUser())) {
        this.clearSession();
        this.redirectToLogin();
        return;
      }

      this.hydrateStoriesFromCache();
      this.bind();
      this.activateTab(this.activeTab);
    }

    readConfig() {
      const configEl = this.root.querySelector('[data-admin-portal-config]');
      const authConfig = getAuthConfig();
      let sectionConfig = {};

      try {
        sectionConfig = JSON.parse(configEl ? configEl.textContent : '{}');
      } catch (error) {
        sectionConfig = {};
      }

      return Object.assign({}, sectionConfig, {
        endpoint: authConfig.endpoint || sectionConfig.endpoint,
        deviceIdKey: authConfig.deviceIdKey || sectionConfig.deviceIdKey
      });
    }

    bind() {
      this.bindNativePickerShortcuts();

      this.root.querySelectorAll('[data-admin-tab]').forEach((button) => {
        button.addEventListener('click', () => this.activateTab(button.dataset.adminTab));
      });

      const logoutButton = this.root.querySelector('[data-admin-logout]');
      if (logoutButton) {
        logoutButton.addEventListener('click', (event) => this.logout(event));
      }

      const dashboardContent = this.root.querySelector('[data-admin-dashboard]');
      if (dashboardContent) {
        dashboardContent.addEventListener('click', (event) => this.handleDashboardAction(event));
      }

      const storyMore = this.root.querySelector('[data-admin-stories-load-more]');
      if (storyMore) {
        storyMore.addEventListener('click', () => this.loadStories(true));
      }

      const storyRefresh = this.root.querySelector('[data-admin-stories-refresh]');
      if (storyRefresh) {
        storyRefresh.addEventListener('click', () => this.loadStories(true, storyRefresh));
      }

      const createStory = this.root.querySelector('[data-admin-story-create]');
      if (createStory) {
        createStory.addEventListener('click', () => this.openCreateStoryModal());
      }

      const dropsRefresh = this.root.querySelector('[data-admin-drops-refresh]');
      if (dropsRefresh) {
        dropsRefresh.addEventListener('click', () => this.loadDrops(dropsRefresh));
      }

      const dropsKnifeRegistryLink = this.root.querySelector('[data-admin-drops-knife-registry-link]');
      if (dropsKnifeRegistryLink) {
        dropsKnifeRegistryLink.addEventListener('click', () => this.activateTab('knife-registry'));
      }

      const knifeRegistryRefresh = this.root.querySelector('[data-admin-knife-registry-refresh]');
      if (knifeRegistryRefresh) {
        knifeRegistryRefresh.addEventListener('click', () => this.loadKnifeRegistrations(true, knifeRegistryRefresh));
      }

      const knifeRegistryExport = this.root.querySelector('[data-admin-knife-registry-export]');
      if (knifeRegistryExport) {
        knifeRegistryExport.addEventListener('click', () => this.exportKnifeRegistrationsCsv(knifeRegistryExport));
      }

      const knifeRegistrySearch = this.root.querySelector('[data-admin-knife-registry-search]');
      if (knifeRegistrySearch) {
        knifeRegistrySearch.addEventListener('input', (event) => {
          this.knifeRegistrationFilters.search = event.target.value;
          window.clearTimeout(this.knifeRegistrationsSearchTimer);
          this.knifeRegistrationsSearchTimer = window.setTimeout(() => {
            this.resetKnifeRegistrationsPaging();
            this.loadKnifeRegistrationsPage();
          }, 300);
        });
      }

      const knifeRegistryStatus = this.root.querySelector('[data-admin-knife-registry-status]');
      if (knifeRegistryStatus) {
        knifeRegistryStatus.addEventListener('change', (event) => {
          this.knifeRegistrationFilters.registration_status = event.target.value;
          this.resetKnifeRegistrationsPaging();
          this.loadKnifeRegistrationsPage();
        });
      }

      const knifeRegistryFounders = this.root.querySelector('[data-admin-knife-registry-founders]');
      if (knifeRegistryFounders) {
        knifeRegistryFounders.addEventListener('change', (event) => {
          this.knifeRegistrationFilters.is_founders_run = event.target.value;
          this.resetKnifeRegistrationsPaging();
          this.loadKnifeRegistrationsPage();
        });
      }

      const knifeRegistryDateFrom = this.root.querySelector('[data-admin-knife-registry-date-from]');
      if (knifeRegistryDateFrom) {
        knifeRegistryDateFrom.addEventListener('change', (event) => {
          this.knifeRegistrationFilters.created_after = event.target.value;
          this.resetKnifeRegistrationsPaging();
          this.loadKnifeRegistrationsPage();
        });
      }

      const knifeRegistryDateTo = this.root.querySelector('[data-admin-knife-registry-date-to]');
      if (knifeRegistryDateTo) {
        knifeRegistryDateTo.addEventListener('change', (event) => {
          this.knifeRegistrationFilters.created_before = event.target.value;
          this.resetKnifeRegistrationsPaging();
          this.loadKnifeRegistrationsPage();
        });
      }

      const knifeRegistryClear = this.root.querySelector('[data-admin-knife-registry-clear]');
      if (knifeRegistryClear) {
        knifeRegistryClear.addEventListener('click', () => {
          window.clearTimeout(this.knifeRegistrationsSearchTimer);
          this.knifeRegistrationFilters = {
            search: '',
            registration_status: '',
            is_founders_run: '',
            created_after: '',
            created_before: ''
          };
          if (knifeRegistrySearch) knifeRegistrySearch.value = '';
          if (knifeRegistryStatus) knifeRegistryStatus.value = '';
          if (knifeRegistryFounders) knifeRegistryFounders.value = '';
          if (knifeRegistryDateFrom) knifeRegistryDateFrom.value = '';
          if (knifeRegistryDateTo) knifeRegistryDateTo.value = '';
          this.resetKnifeRegistrationsPaging();
          this.loadKnifeRegistrationsPage();
        });
      }

      const knifeRegistryList = this.root.querySelector('[data-admin-knife-registry-list]');
      if (knifeRegistryList) {
        knifeRegistryList.addEventListener('click', (event) => this.handleKnifeRegistrationAction(event));
      }

      const knifeRegistryPagination = this.root.querySelector('[data-admin-knife-registry-pagination]');
      if (knifeRegistryPagination) {
        knifeRegistryPagination.addEventListener('click', (event) => this.handleKnifeRegistrationPagination(event));
      }

      const knifeRegistrationStatusForm = this.root.querySelector('[data-admin-knife-registration-status-form]');
      if (knifeRegistrationStatusForm) {
        knifeRegistrationStatusForm.addEventListener('submit', (event) => this.saveKnifeRegistrationStatus(event));
      }

      const knifeRegistrationForm = this.root.querySelector('[data-admin-knife-registration-form]');
      if (knifeRegistrationForm) {
        knifeRegistrationForm.addEventListener('submit', (event) => this.submitKnifeRegistrationEdit(event));
        knifeRegistrationForm.addEventListener('click', (event) => this.handleKnifeRegistrationPhotoAction(event));

        const purchaseLocationSelect = knifeRegistrationForm.querySelector('[data-admin-knife-registration-purchase-location]');
        if (purchaseLocationSelect) {
          purchaseLocationSelect.addEventListener('change', () => this.syncKnifeRegistrationPurchaseLocation(knifeRegistrationForm));
        }

        knifeRegistrationForm.querySelectorAll('[data-admin-knife-registration-photo-input]').forEach((input) => {
          input.addEventListener('change', (event) => this.handleKnifeRegistrationPhotoInput(event));
        });
      }

      const deleteKnifeRegistrationForm = this.root.querySelector('[data-admin-delete-knife-registration-form]');
      if (deleteKnifeRegistrationForm) {
        deleteKnifeRegistrationForm.addEventListener('submit', (event) => this.confirmDeleteKnifeRegistration(event));
      }

      const createDrop = this.root.querySelector('[data-admin-drop-create]');
      if (createDrop) {
        createDrop.addEventListener('click', () => this.openDropModal());
      }

      const dropList = this.root.querySelector('[data-admin-drops-list]');
      if (dropList) {
        dropList.addEventListener('click', (event) => this.handleDropAction(event));
      }

      const dropForm = this.root.querySelector('[data-admin-drop-form]');
      if (dropForm) {
        dropForm.addEventListener('submit', (event) => this.submitDrop(event));
      }

      const collectionSearch = this.root.querySelector('[data-admin-drop-collection-search]');
      if (collectionSearch) {
        collectionSearch.addEventListener('input', (event) => this.queueDropCollectionSearch(event.target.value));
        collectionSearch.addEventListener('click', () => this.openDropCollectionDropdown({ search: true }));
        collectionSearch.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.closeDropCollectionDropdown();
            return;
          }

          if (event.key === 'ArrowDown') {
            event.preventDefault();
            this.openDropCollectionDropdown({ search: true });
          }
        });
      }

      const collectionResults = this.root.querySelector('[data-admin-drop-collection-results]');
      if (collectionResults) {
        collectionResults.addEventListener('click', (event) => this.handleDropCollectionSelection(event));
      }

      const storyForm = this.root.querySelector('[data-admin-story-form]');
      if (storyForm) {
        storyForm.addEventListener('submit', (event) => this.submitStory(event));
        this.bindRemarksRequirement(storyForm);

        const speciesSelect = storyForm.querySelector('select[name="harvested_species"]');
        if (speciesSelect) {
          speciesSelect.addEventListener('change', () => this.syncSpeciesOtherField(storyForm));
        }
      }

      const newMediaInput = this.root.querySelector('[data-admin-story-form] input[name="media"]');
      if (newMediaInput) {
        newMediaInput.addEventListener('change', (event) => this.handleNewMediaSelection(event));
      }

      const newMediaPreview = this.root.querySelector('[data-admin-new-media-preview]');
      if (newMediaPreview) {
        newMediaPreview.addEventListener('click', (event) => this.removeNewMedia(event));
      }

      this.root.querySelectorAll('select[name="phone_country_code"], input[name="phone_national_number"]').forEach((field) => {
        const clearPhoneValidity = () => {
          const form = field.closest('form');
          const phoneInput = form ? form.elements.phone_national_number : null;
          if (phoneInput) phoneInput.setCustomValidity('');
        };

        field.addEventListener('input', clearPhoneValidity);
        field.addEventListener('change', clearPhoneValidity);
      });

      const search = this.root.querySelector('[data-admin-stories-search]');
      if (search) {
        search.addEventListener('input', (event) => {
          this.storyFilters.search = event.target.value;
          this.storiesPage = 1;
          this.renderStories();
        });
      }

      const status = this.root.querySelector('[data-admin-stories-status]');
      if (status) {
        status.addEventListener('change', (event) => {
          this.storyFilters.status = event.target.value;
          this.storiesPage = 1;
          this.renderStories();
        });
      }

      const featured = this.root.querySelector('[data-admin-stories-featured]');
      if (featured) {
        featured.addEventListener('change', (event) => {
          this.storyFilters.featured = event.target.value;
          this.storiesPage = 1;
          this.renderStories();
        });
      }

      const honor = this.root.querySelector('[data-admin-stories-honor]');
      if (honor) {
        honor.addEventListener('change', (event) => {
          this.storyFilters.honor = event.target.value;
          this.storiesPage = 1;
          this.renderStories();
        });
      }

      const clear = this.root.querySelector('[data-admin-stories-clear]');
      if (clear) {
        clear.addEventListener('click', () => this.clearStoryFilters());
      }

      const storyList = this.root.querySelector('[data-admin-stories-list]');
      if (storyList) {
        storyList.addEventListener('click', (event) => this.handleStoryAction(event));
      }

      const honorList = this.root.querySelector('[data-admin-honor-list]');
      if (honorList) {
        honorList.addEventListener('click', (event) => this.handleStoryAction(event));
      }

      const storiesPagination = this.root.querySelector('[data-admin-stories-pagination]');
      if (storiesPagination) {
        storiesPagination.addEventListener('click', (event) => this.handlePagination(event, 'stories'));
      }

      const honorPagination = this.root.querySelector('[data-admin-honor-pagination]');
      if (honorPagination) {
        honorPagination.addEventListener('click', (event) => this.handlePagination(event, 'honor'));
      }

      const reviewForm = this.root.querySelector('[data-admin-review-form]');
      if (reviewForm) {
        reviewForm.addEventListener('submit', (event) => this.saveStoryReview(event));
        this.bindRemarksRequirement(reviewForm);
      }

      const deleteStoryForm = this.root.querySelector('[data-admin-delete-story-form]');
      if (deleteStoryForm) {
        deleteStoryForm.addEventListener('submit', (event) => this.confirmDeleteStory(event));
      }

      const cancelDropForm = this.root.querySelector('[data-admin-cancel-drop-form]');
      if (cancelDropForm) {
        cancelDropForm.addEventListener('submit', (event) => this.confirmCancelDrop(event));
      }

      const endDropForm = this.root.querySelector('[data-admin-end-drop-form]');
      if (endDropForm) {
        endDropForm.addEventListener('submit', (event) => this.confirmEndDrop(event));
      }

      this.root.querySelectorAll('[data-admin-modal-close]').forEach((button) => {
        button.addEventListener('click', () => this.closeModals());
      });

      this.root.querySelectorAll('[data-admin-modal]').forEach((modal) => {
        modal.addEventListener('click', (event) => {
          if (event.target === modal) this.closeModals();
        });
      });

      this.root.addEventListener('click', (event) => {
        if (!event.target.closest('[data-admin-drop-collection-picker]')) {
          this.closeDropCollectionDropdown();
        }

        const galleryThumb = event.target.closest('[data-admin-story-gallery-thumb]');
        if (galleryThumb && this.root.contains(galleryThumb)) {
          this.setStoryGalleryMedia(galleryThumb);
          return;
        }

        const mediaButton = event.target.closest('[data-admin-media-lightbox]');
        if (mediaButton && this.root.contains(mediaButton)) {
          this.openMediaLightbox(mediaButton);
          return;
        }

        const closeButton = event.target.closest('[data-admin-lightbox-close]');
        if (closeButton && this.root.contains(closeButton)) {
          this.closeMediaLightbox();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        if (this.isDropCollectionDropdownOpen()) {
          this.closeDropCollectionDropdown();
          return;
        }

        if (this.isMediaLightboxOpen()) {
          this.closeMediaLightbox();
          return;
        }

        this.closeModals();
      });
    }

    bindNativePickerShortcuts() {
      this.root.querySelectorAll('input.input[type="date"], input.input[type="time"]').forEach((input) => {
        if (input.dataset.nativePickerBound === 'true') return;
        input.dataset.nativePickerBound = 'true';

        if (String(input.getAttribute('type') || input.type || '').toLowerCase() === 'date') {
          if (!input.hasAttribute('max')) input.setAttribute('max', '9999-12-31');
          preventLongDateYear(input);
          input.addEventListener('input', () => preventLongDateYear(input));
          input.addEventListener('change', () => preventLongDateYear(input));
        }

        input.addEventListener('pointerdown', (event) => {
          if (!this.isNativePickerIconClick(input, event) || typeof input.showPicker !== 'function') return;
          event.preventDefault();
          this.openNativePicker(input);
        });

        input.addEventListener('click', (event) => {
          if (!this.isNativePickerIconClick(input, event)) return;
          this.openNativePicker(input);
        });

        input.addEventListener('keydown', (event) => {
          if ((event.key !== 'Enter' && event.key !== ' ') || event.altKey || event.ctrlKey || event.metaKey) return;
          event.preventDefault();
          this.openNativePicker(input);
        });
      });
    }

    isNativePickerIconClick(input, event) {
      const rect = input.getBoundingClientRect();
      const style = window.getComputedStyle(input);
      const iconHitArea = 72;

      if (style.direction === 'rtl') {
        return event.clientX - rect.left <= iconHitArea;
      }

      return rect.right - event.clientX <= iconHitArea;
    }

    openNativePicker(input) {
      try {
        input.focus({ preventScroll: true });
      } catch (error) {
        input.focus();
      }

      if (typeof input.showPicker !== 'function') return;

      try {
        input.showPicker();
      } catch (error) {
        // Some browsers only allow native pickers from specific trusted events.
      }
    }

    activateTab(tabName) {
      if (TAB_NAMES.indexOf(tabName) === -1) return;
      this.activeTab = tabName;

      this.root.querySelectorAll('[data-admin-tab]').forEach((button) => {
        const isActive = button.dataset.adminTab === tabName;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.root.querySelectorAll('[data-admin-panel]').forEach((panel) => {
        const isActive = panel.dataset.adminPanel === tabName;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });

      const usesStories = ['dashboard', 'stories', 'honor'].indexOf(tabName) !== -1;
      if (!this.loaded[tabName] || (usesStories && !this.isStoryCacheFresh())) {
        this.loadTab(tabName);
      }
    }

    loadTab(tabName) {
      if (tabName === 'dashboard') return this.loadDashboard();
      if (tabName === 'drops') return this.loadDrops();
      if (tabName === 'knife-registry') return this.loadKnifeRegistrations(false);
      if (tabName === 'stories') return this.loadStories(false);
      if (tabName === 'honor') return this.loadHallOfHonor();
      if (tabName === 'profile') return this.loadProfile();
      return null;
    }

    getPanel(tabName) {
      return this.root.querySelector(`[data-admin-panel="${tabName}"]`);
    }

    setState(tabName, type, message) {
      const panel = this.getPanel(tabName);
      const state = panel ? panel.querySelector('[data-admin-panel-state]') : null;
      if (!state) return;

      state.hidden = !message;
      state.className = type ? `tkc-admin__state is-${type}` : 'tkc-admin__state';
      state.textContent = message || '';
    }

    setGlobalMessage(message, type) {
      const box = this.root.querySelector('[data-admin-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-admin__message is-${type}` : 'tkc-admin__message';
      box.textContent = message || '';
    }

    showPanelError(tabName, error) {
      const message = error && error.message ? error.message : 'Something went wrong.';
      this.setState(tabName, 'error', message);
    }

    hydrateStoriesFromCache() {
      try {
        const raw = window.sessionStorage.getItem(this.storyCacheKey);
        const cache = raw ? JSON.parse(raw) : null;

        if (!cache || !Array.isArray(cache.stories) || !cache.fetchedAt) return;
        if (cache.query !== this.api.storiesQuery) return;
        if (Date.now() - Number(cache.fetchedAt) >= this.storyCacheMs) return;

        this.allStories = cache.stories;
        this.stories = this.allStories;
        this.storiesFetchedAt = Number(cache.fetchedAt);
      } catch (error) {
        // Session storage may be unavailable or contain stale data.
      }
    }

    persistStoriesCache() {
      try {
        window.sessionStorage.setItem(this.storyCacheKey, JSON.stringify({
          fetchedAt: this.storiesFetchedAt || Date.now(),
          query: this.api.storiesQuery,
          stories: this.allStories
        }));
      } catch (error) {
        // Ignore storage quota/privacy failures.
      }
    }

    getStoryCooldownRemaining() {
      const cooldownUntil = Number(window.localStorage.getItem(this.storyCooldownKey) || 0);
      return Math.max(0, cooldownUntil - Date.now());
    }

    setStoryCooldown(ms) {
      window.localStorage.setItem(this.storyCooldownKey, String(Date.now() + ms));
    }

    clearStoryCooldown() {
      window.localStorage.removeItem(this.storyCooldownKey);
    }

    getInitialStoryLoadDelay() {
      const loginAt = Number(window.localStorage.getItem(this.loginAtKey) || 0);
      if (!loginAt) return 0;

      const elapsed = Date.now() - loginAt;
      if (elapsed < 0 || elapsed >= this.initialStoryLoadDelayMs) return 0;

      return this.initialStoryLoadDelayMs - elapsed;
    }

    isStoryCacheFresh() {
      return !!(this.storiesFetchedAt && Date.now() - this.storiesFetchedAt < this.storyCacheMs);
    }

    async fetchAllStories(options) {
      const force = !!(options && options.force);

      if (!force && this.isStoryCacheFresh()) {
        return this.allStories;
      }

      if (this.storiesFetchPromise) {
        return this.storiesFetchPromise;
      }

      this.storiesFetchPromise = (async () => {
        const cooldownRemaining = this.getStoryCooldownRemaining();
        if (cooldownRemaining > 0) {
          throw new Error(`API rate limit is active. Please wait ${Math.ceil(cooldownRemaining / 1000)} seconds and try again.`);
        }

        const initialDelay = this.getInitialStoryLoadDelay();
        if (initialDelay > 0) {
          await wait(initialDelay);
        }

        let after = null;
        let stories = [];
        const seenStoryIds = {};
        const seenCursors = {};
        let guard = 0;

        do {
          let result;

          try {
            result = await this.api.stories({ first: this.storyFetchPageSize, after });
          } catch (error) {
            if (error && error.isThrottled) {
              this.setStoryCooldown(60000);
            }

            throw error;
          }

          const pageStories = getConnectionItems(result);
          pageStories.forEach((story) => {
            const storyKey = story && story.id ? `id:${story.id}` : `index:${stories.length}`;
            if (seenStoryIds[storyKey]) return;
            seenStoryIds[storyKey] = true;
            stories.push(story);
          });

          const pageInfo = getConnectionPageInfo(result);
          const nextCursor = getStoryEndCursor(pageInfo, result && Array.isArray(result.edges) ? result.edges : pageStories);
          const shouldFetchNextPage = hasNextStoryPage(pageInfo) && nextCursor && !seenCursors[nextCursor];
          after = shouldFetchNextPage ? nextCursor : null;
          if (nextCursor) seenCursors[nextCursor] = true;
          guard += 1;

          if (after && this.storyPageDelayMs > 0) {
            await wait(this.storyPageDelayMs);
          }
        } while (after && guard < 100);

        this.allStories = stories;
        this.stories = this.allStories;
        this.storiesFetchedAt = Date.now();
        this.clearStoryCooldown();
        this.persistStoriesCache();
        return this.allStories;
      })();

      try {
        return await this.storiesFetchPromise;
      } finally {
        this.storiesFetchPromise = null;
      }
    }

    countStories(stories) {
      return stories.reduce((acc, story) => {
        const status = normalizeStatus(story.status);
        acc.total += 1;

        if (status.indexOf('PENDING') !== -1 || status.indexOf('REVIEW') !== -1 || isNeedsEditsStatus(status)) {
          acc.pending += 1;
        } else if (status === 'APPROVED' || status === 'LIVE' || status === 'PUBLISHED') {
          acc.approved += 1;
        } else if (status === 'REJECTED' || status === 'DENIED') {
          acc.rejected += 1;
        }

        if (isHallOfHonor(story)) {
          acc.honor += 1;
        }

        if (story.is_featured) {
          acc.featured += 1;
        }

        return acc;
      }, { total: 0, pending: 0, approved: 0, rejected: 0, featured: 0, honor: 0 });
    }

    async loadDashboard() {
      this.setState('dashboard', 'loading', 'Loading dashboard...');

      try {
        const stories = await this.fetchAllStories();
        const counts = this.countStories(stories);
        const recentStories = stories
          .slice()
          .sort((a, b) => new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime())
          .slice(0, 4);
        const content = this.root.querySelector('[data-admin-dashboard]');

        if (content) {
          content.innerHTML = `
            <div class="tkc-admin__dashboard-hero">
              <div>
                <h3>Admin dashboard</h3>
                <p>Review every submitted story, monitor Hall of Honor entries, and keep the TKC archive organized.</p>
              </div>
              <div class="tkc-admin__dashboard-hero-badge">
                <strong>${escapeHtml(counts.pending)}</strong>
                <span>Awaiting review</span>
              </div>
            </div>

            <div class="tkc-admin__stats-grid">
              ${[
                this.renderStatCard('All Stories', counts.total, 'stories'),
                this.renderStatCard('Pending', counts.pending, 'pending'),
                this.renderStatCard('Approved', counts.approved, 'approved'),
                this.renderStatCard('Featured', counts.featured, 'featured'),
                this.renderStatCard('Hall of Honor', counts.honor, 'honor')
              ].join('')}
            </div>

            <div class="tkc-admin__dashboard-grid">
              <div class="tkc-admin__dashboard-card">
                <h3>Recent stories</h3>
                ${this.renderRecentStories(recentStories)}
              </div>
              <div class="tkc-admin__dashboard-card">
                <h3>Admin shortcuts</h3>
                <div class="tkc-admin__quick-actions">
                  <button class="tkc-admin__quick-action" type="button" data-admin-dashboard-action="create-story">
                    <span>Create story</span>
                    <span aria-hidden="true">+</span>
                  </button>
                  <button class="tkc-admin__quick-action" type="button" data-admin-dashboard-action="create-drop">
                    <span>Create drop</span>
                    <span aria-hidden="true">+</span>
                  </button>
                  <button class="tkc-admin__quick-action" type="button" data-admin-dashboard-action="drops">
                    <span>Open drops</span>
                    <span aria-hidden="true">&rsaquo;</span>
                  </button>
                  <button class="tkc-admin__quick-action" type="button" data-admin-dashboard-action="stories">
                    <span>Open all stories</span>
                    <span aria-hidden="true">&rsaquo;</span>
                  </button>
                  <button class="tkc-admin__quick-action" type="button" data-admin-dashboard-action="honor">
                    <span>View Hall of Honor</span>
                    <span aria-hidden="true">&rsaquo;</span>
                  </button>
                  <button class="tkc-admin__quick-action" type="button" data-admin-dashboard-action="profile">
                    <span>View profile</span>
                    <span aria-hidden="true">&rsaquo;</span>
                  </button>
                </div>
              </div>
            </div>
          `;
        }

        this.setState('dashboard', '', '');
        this.loaded.dashboard = true;
      } catch (error) {
        this.showPanelError('dashboard', error);
      }
    }

    renderStatCard(label, value, iconName) {
      return `
        <div class="tkc-admin__stat">
          <div class="tkc-admin__stat-head">
            <span>${escapeHtml(label)}</span>
            <span class="tkc-admin__stat-icon" aria-hidden="true">${ICONS[iconName] || ICONS.stories}</span>
          </div>
          <strong>${escapeHtml(value)}</strong>
        </div>
      `;
    }

    renderRecentStories(stories) {
      if (!stories.length) {
        return '<p class="tkc-admin__empty">No stories found.</p>';
      }

      return `
        <div class="tkc-admin__recent-list">
          ${stories.map((story) => `
            <article class="tkc-admin__recent-item">
              <div>
                <h4>${escapeHtml(story.title || 'Untitled story')}</h4>
                <p>${escapeHtml(story.created_at ? `Submitted ${formatDate(story.created_at)}` : 'Submission date unavailable')}</p>
              </div>
              <span class="tkc-admin__badge is-${escapeHtml(statusClass(story.status))}">${escapeHtml(story.status || 'Unknown')}</span>
            </article>
          `).join('')}
        </div>
      `;
    }

    handleDashboardAction(event) {
      const button = event.target.closest('[data-admin-dashboard-action]');
      if (!button) return;

      if (button.dataset.adminDashboardAction === 'create-drop') {
        this.activateTab('drops');
        this.openDropModal();
        return;
      }

      if (button.dataset.adminDashboardAction === 'create-story') {
        this.activateTab('stories');
        this.openCreateStoryModal();
        return;
      }

      this.activateTab(button.dataset.adminDashboardAction);
    }

    async loadDrops(button) {
      this.setState('drops', 'loading', 'Loading drops...');

      try {
        this.setButtonPending(button, true, 'Refreshing...');
        const drops = await this.api.drops();
        this.drops = Array.isArray(drops) ? drops : [];
        this.renderDrops();
        this.setState('drops', this.drops.length ? '' : 'empty', this.drops.length ? '' : 'No drops found.');
        this.loaded.drops = true;
      } catch (error) {
        this.showPanelError('drops', error);
      } finally {
        this.setButtonPending(button, false);
      }
    }

    renderDrops() {
      const list = this.root.querySelector('[data-admin-drops-list]');
      if (!list) return;

      const drops = this.drops
        .slice()
        .sort((a, b) => new Date(getDropCreatedAt(b) || 0).getTime() - new Date(getDropCreatedAt(a) || 0).getTime());

      list.innerHTML = drops.length
        ? drops.map((drop) => this.renderDropCard(drop)).join('')
        : '<p class="tkc-admin__empty">No drops found.</p>';
    }

    renderDropCard(drop) {
      const dropId = escapeHtml(drop.id || '');
      const title = getDropCollectionTitle(drop);
      const collectionAdminId = getShopifyNumericId(getDropCollectionId(drop));
      const collectionAdminUrl = collectionAdminId ? `/admin/collections/${encodeURIComponent(collectionAdminId)}` : '';
      const launchAt = getDropLaunchAt(drop);
      const timezone = drop.timezone || 'America/Chicago';
      const status = normalizeDropStatus(drop.status);
      const canEditCancel = isScheduledDrop(drop);
      const canEnd = isLiveDrop(drop);
      const quantity = getDropQuantity(drop);
      const productsCount = getDropProductsCount(drop);
      const teaser = getDropTeaser(drop);
      const actions = [
        canEditCancel ? `<button class="tkc-admin__action-btn is-status" type="button" data-admin-drop-action="edit" data-admin-drop-id="${dropId}">Edit</button>` : '',
        canEditCancel ? `<button class="tkc-admin__action-btn tkc-admin__icon-btn--danger" type="button" data-admin-drop-action="cancel" data-admin-drop-id="${dropId}">Cancel</button>` : '',
        canEnd ? `<button class="tkc-admin__action-btn tkc-admin__icon-btn--danger" type="button" data-admin-drop-action="end" data-admin-drop-id="${dropId}">End</button>` : ''
      ].filter(Boolean).join('');
      const details = [
        `Launch: ${formatDropDateTime(launchAt, timezone)}`,
        quantity !== '' ? `Quantity per variant: ${quantity}` : '',
        productsCount !== '' ? `Products: ${productsCount}` : ''
      ].filter(Boolean);

      return `
        <article class="tkc-admin__record tkc-admin__drop-card" data-admin-drop-id="${dropId}">
          <div class="tkc-admin__record-head">
            <div>
              <h3 class="tkc-admin__drop-card-title">${escapeHtml(title)}</h3>
            </div>
            <span class="tkc-admin__badge is-${escapeHtml(statusClass(status))}">${escapeHtml(status)}</span>
          </div>

          <p class="tkc-admin__drop-card-link-row">${collectionAdminUrl ? `<a class="tkc-admin__drop-card-link" href="${escapeHtml(collectionAdminUrl)}" target="_blank" rel="noopener noreferrer">Change Products at Shopify Admin ${ICONS.external}</a>` : 'Shopify collection'}</p>

          <div class="tkc-admin__record-details tkc-admin__drop-card-details">
            ${details.map((item) => `<span>${escapeHtml(item)}</span>`).join('')}
          </div>

          ${teaser ? `<p class="tkc-admin__drop-card-meta">${escapeHtml(teaser)}</p>` : ''}

          ${actions ? `<div class="tkc-admin__record-actions">${actions}</div>` : ''}
        </article>
      `;
    }

    // Registrations are searched and filtered server-side via the `filter` input on
    // adminKnifeRegistrations (search, registration_status, is_founders_run, created_after/before),
    // so we only ever hold the currently displayed page in memory - no client-side filtering.
    buildKnifeRegistrationFilter() {
      const filters = this.knifeRegistrationFilters || {};
      const filter = {};

      const search = String(filters.search || '').trim();
      if (search) filter.search = search;
      if (filters.registration_status) filter.registration_status = filters.registration_status;
      if (filters.is_founders_run === 'true') filter.is_founders_run = true;
      if (filters.is_founders_run === 'false') filter.is_founders_run = false;
      if (filters.created_after) filter.created_after = `${filters.created_after}T00:00:00.000Z`;
      if (filters.created_before) filter.created_before = `${filters.created_before}T23:59:59.999Z`;

      return filter;
    }

    resetKnifeRegistrationsPaging() {
      this.knifeRegistrationsCursors = [null];
      this.knifeRegistrationsPageIndex = 0;
    }

    async fetchKnifeRegistrationsPage() {
      const requestId = (this.knifeRegistrationsRequestId += 1);
      const filter = this.buildKnifeRegistrationFilter();
      filter.first = this.knifeRegistrationsPerPage;

      const cursor = this.knifeRegistrationsCursors[this.knifeRegistrationsPageIndex];
      if (cursor) filter.after = cursor;

      const result = await this.api.knifeRegistrations(filter);

      // A newer request (e.g. from further typing) landed first - drop this stale response.
      if (requestId !== this.knifeRegistrationsRequestId) return null;

      this.knifeRegistrations = getConnectionItems(result);
      this.knifeRegistrationsPageInfo = getConnectionPageInfo(result);
      return this.knifeRegistrations;
    }

    async loadKnifeRegistrationsPage(button) {
      this.setState('knife-registry', 'loading', 'Loading registered knives...');
      if (button) this.setButtonPending(button, true, 'Refreshing...');

      try {
        const registrations = await this.fetchKnifeRegistrationsPage();
        if (registrations === null) return;

        const count = this.renderKnifeRegistrations();
        this.setState('knife-registry', count ? '' : 'empty', count ? '' : 'No registered knives match your search.');
        this.loaded['knife-registry'] = true;
      } catch (error) {
        this.showPanelError('knife-registry', error);
      } finally {
        if (button) this.setButtonPending(button, false);
      }
    }

    loadKnifeRegistrations(forceRefresh, button) {
      if (forceRefresh) this.resetKnifeRegistrationsPaging();
      return this.loadKnifeRegistrationsPage(button);
    }

    async exportKnifeRegistrationsCsv(button) {
      try {
        this.setButtonPending(button, true, 'Exporting...');
        const csv = await this.api.exportKnifeRegistrationsCsv(this.buildKnifeRegistrationFilter());

        if (!csv) {
          this.setGlobalMessage('No CSV data was returned.', 'error');
          return;
        }

        // Prepend a UTF-8 BOM so Excel opens accented/special characters correctly.
        const blob = new Blob(['﻿', csv], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        const timestamp = new Date().toISOString().slice(0, 10);

        link.href = url;
        link.download = `knife-registrations-${timestamp}.csv`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.setGlobalMessage(error.message || 'Registrations could not be exported.', 'error');
      } finally {
        this.setButtonPending(button, false);
      }
    }

    renderKnifeRegistrations() {
      const list = this.root.querySelector('[data-admin-knife-registry-list]');
      if (!list) return 0;

      const items = this.knifeRegistrations || [];
      list.innerHTML = items.length
        ? items.map((registration) => this.renderKnifeRegistrationCard(registration)).join('')
        : '<p class="tkc-admin__empty">No registered knives match your search.</p>';

      this.renderKnifeRegistrationPagination();
      return items.length;
    }

    renderKnifeRegistrationPagination() {
      const container = this.root.querySelector('[data-admin-knife-registry-pagination]');
      if (!container) return;

      const pageInfo = this.knifeRegistrationsPageInfo || {};
      const hasPrevious = this.knifeRegistrationsPageIndex > 0;
      const hasNext = !!pageInfo.hasNextPage;
      const shouldShow = hasPrevious || hasNext;

      container.hidden = !shouldShow;
      if (!shouldShow) {
        container.innerHTML = '';
        return;
      }

      container.innerHTML = `
        <span class="tkc-admin__pagination-info">Page ${escapeHtml(this.knifeRegistrationsPageIndex + 1)}</span>
        <button class="tkc-admin__pagination-btn" type="button" data-admin-page="knife-registry-prev" ${hasPrevious ? '' : 'disabled'}>Previous</button>
        <button class="tkc-admin__pagination-btn" type="button" data-admin-page="knife-registry-next" ${hasNext ? '' : 'disabled'}>Next</button>
      `;
    }

    handleKnifeRegistrationPagination(event) {
      const button = event.target.closest('[data-admin-page]');
      if (!button || button.disabled) return;

      const isNext = button.dataset.adminPage.indexOf('next') !== -1;

      if (isNext) {
        const pageInfo = this.knifeRegistrationsPageInfo || {};
        if (!pageInfo.hasNextPage || !pageInfo.endCursor) return;

        if (this.knifeRegistrationsCursors.length === this.knifeRegistrationsPageIndex + 1) {
          this.knifeRegistrationsCursors.push(pageInfo.endCursor);
        }
        this.knifeRegistrationsPageIndex += 1;
      } else {
        if (this.knifeRegistrationsPageIndex <= 0) return;
        this.knifeRegistrationsPageIndex -= 1;
      }

      this.loadKnifeRegistrationsPage();

      const list = this.root.querySelector('[data-admin-knife-registry-list]');
      if (list) {
        window.requestAnimationFrame(() => list.scrollIntoView({ behavior: 'smooth', block: 'start' }));
      }
    }

    renderKnifeRegistrationCardMedia(registration) {
      if (!registration.knife_photo_url) {
        return '<span class="tkc-admin__story-card-placeholder">No photo added</span>';
      }

      const url = escapeHtml(registration.knife_photo_url);
      return `<img class="tkc-admin__story-card-image" src="${url}" alt="${escapeHtml(registration.knife_model || 'Registered knife')}" loading="lazy">`;
    }

    renderKnifeRegistrationCard(registration) {
      const id = escapeHtml(registration.id || '');
      const ownerName = [registration.first_name, registration.last_name].filter(Boolean).join(' ') || 'Unknown owner';
      const status = registration.registration_status || 'Unknown';
      const title = registration.knife_model || 'Registered knife';
      const meta = [
        `Owner: ${ownerName}`,
        registration.serial_number ? `Serial: ${registration.serial_number}` : ''
      ].filter(Boolean);

      return `
        <article class="tkc-admin__record tkc-admin__story-card" data-admin-knife-registration-id="${id}">
          <button class="tkc-admin__story-card-media" type="button" data-admin-knife-registration-action="view" data-admin-knife-registration-id="${id}" aria-label="View ${escapeHtml(title)}">
            ${this.renderKnifeRegistrationCardMedia(registration)}
          </button>
          <div class="tkc-admin__story-card-body">
            <div>
              <button class="tkc-admin__story-card-title" type="button" data-admin-knife-registration-action="view" data-admin-knife-registration-id="${id}">
                ${escapeHtml(title)}
              </button>
              <p class="tkc-admin__story-card-meta">${escapeHtml(meta.join(' - '))}</p>
              <p class="tkc-admin__story-card-meta">${escapeHtml(registration.created_at ? `Registered ${formatDate(registration.created_at)}` : 'Registration date unavailable')}</p>
            </div>

            <div class="tkc-admin__record-meta">
              <span class="tkc-admin__badge is-${escapeHtml(statusClass(status))}">${escapeHtml(status)}</span>
            </div>

            <div class="tkc-admin__record-actions">
              <button class="tkc-admin__action-btn is-status" type="button" data-admin-knife-registration-action="status" data-admin-knife-registration-id="${id}">Change Status</button>
              <button class="tkc-admin__icon-btn" type="button" data-admin-knife-registration-action="edit" data-admin-knife-registration-id="${id}" title="Edit registration" aria-label="Edit registration">${ICONS.edit}</button>
              <button class="tkc-admin__icon-btn tkc-admin__icon-btn--danger" type="button" data-admin-knife-registration-action="delete" data-admin-knife-registration-id="${id}" title="Delete registration" aria-label="Delete registration">${ICONS.delete}</button>
            </div>
            ${registration.duplicate_serial_number ? '<p class="tkc-admin__remarks">This serial number matches another registration on file.</p>' : ''}
          </div>
        </article>
      `;
    }

    findKnifeRegistration(id) {
      return this.knifeRegistrations.find((item) => item && String(item.id) === String(id)) || null;
    }

    handleKnifeRegistrationAction(event) {
      const button = event.target.closest('[data-admin-knife-registration-action]');
      if (!button || button.disabled) return;

      const registration = this.findKnifeRegistration(button.dataset.adminKnifeRegistrationId);
      if (!registration) return;

      const action = button.dataset.adminKnifeRegistrationAction;
      if (action === 'view') return this.openKnifeRegistrationDetails(registration);
      if (action === 'status') return this.openKnifeRegistrationStatusModal(registration);
      if (action === 'edit') return this.openKnifeRegistrationEditModal(registration);
      if (action === 'delete') return this.openDeleteKnifeRegistrationModal(registration);

      return null;
    }

    openKnifeRegistrationDetails(registration) {
      const container = this.root.querySelector('[data-admin-knife-registration-details]');
      if (!container) return;

      container.innerHTML = this.renderKnifeRegistrationDetails(registration);
      this.openModal('knife-registration-details');
    }

    renderKnifeRegistrationDetails(registration) {
      const title = registration.knife_model || 'Registered knife';
      const photos = [
        { label: 'Knife photo', url: registration.knife_photo_url },
        { label: 'Certificate photo', url: registration.certificate_photo_url }
      ].filter((item) => item.url);

      const primary = photos[0] || null;
      const mainMedia = primary
        ? `
          <button class="tkc-admin__story-view-main" type="button" data-admin-story-gallery-main data-admin-media-lightbox data-media-type="image" data-media-url="${escapeHtml(primary.url)}" aria-label="Open image preview">
            <img class="tkc-admin__story-view-media-file" src="${escapeHtml(primary.url)}" alt="${escapeHtml(primary.label)}" loading="eager">
          </button>
        `
        : '<div class="tkc-admin__story-view-main is-empty">No photos added</div>';

      const thumbs = photos.length > 1
        ? `<div class="tkc-admin__story-view-thumbs">${photos.map((item, index) => `
            <button class="tkc-admin__story-view-thumb${index === 0 ? ' is-active' : ''}" type="button" data-admin-story-gallery-thumb data-media-type="image" data-media-url="${escapeHtml(item.url)}" aria-label="Show ${escapeHtml(item.label)}"${index === 0 ? ' aria-current="true"' : ''}>
              <img src="${escapeHtml(item.url)}" alt="${escapeHtml(item.label)} thumbnail" loading="lazy">
            </button>
          `).join('')}</div>`
        : '';

      const rows = [
        ['First name', registration.first_name],
        ['Last name', registration.last_name],
        ['Email', registration.email],
        ['Phone', registration.phone],
        ['Mailing address', registration.address],
        ['Knife model', registration.knife_model],
        ['Serial number', registration.serial_number],
        ['Handle material', registration.handle_material],
        ['Blade steel', registration.blade_steel],
        ['Purchase date', registration.purchase_date ? formatDate(registration.purchase_date) : ''],
        ['Order number', registration.order_number],
        ['Purchase location', registration.purchase_location],
        ['Purchase location details', registration.purchase_location_other],
        ['Founders Run number', registration.founders_run_number],
        ['Certificate number', registration.certificate_number],
        ['Box number', registration.box_number],
        ['Customer notes', registration.customer_notes],
        ['Admin notes', registration.admin_notes],
        ['Status', registration.registration_status],
        ['Registered', registration.created_at ? formatDate(registration.created_at) : '']
      ];

      const detailRows = rows
        .filter((row) => row[1] !== null && row[1] !== undefined && row[1] !== '')
        .map((row) => `
          <div class="tkc-admin__detail-row">
            <dt>${escapeHtml(row[0])}</dt>
            <dd>${escapeHtml(String(row[1]))}</dd>
          </div>
        `).join('');

      return `
        <div class="tkc-admin__story-view" data-admin-story-gallery>
          <div class="tkc-admin__story-view-media">
            ${mainMedia}
            ${thumbs}
          </div>
          <div class="tkc-admin__story-view-content">
            <p class="tkc-admin__story-view-kicker">Knife Registration</p>
            <h3 class="tkc-admin__detail-title">${escapeHtml(title)}</h3>
            ${registration.duplicate_serial_number ? '<p class="tkc-admin__remarks">This serial number matches another registration on file.</p>' : ''}
            <dl class="tkc-admin__detail-list">${detailRows}</dl>
          </div>
        </div>
      `;
    }

    openKnifeRegistrationStatusModal(registration) {
      const form = this.root.querySelector('[data-admin-knife-registration-status-form]');
      const title = this.root.querySelector('[data-admin-knife-registration-status-title]');
      if (!form || !registration) return;

      form.reset();
      form.elements.id.value = registration.id || '';
      if (title) title.textContent = `Change Status: ${registration.knife_model || 'Registered knife'}`;

      const normalized = normalizeStatus(registration.registration_status);
      const options = Array.from(form.elements.registration_status.options).map((option) => option.value);
      form.elements.registration_status.value = options.indexOf(normalized) !== -1 ? normalized : options[0];
      if (form.elements.admin_notes) form.elements.admin_notes.value = registration.admin_notes || '';

      this.setKnifeRegistrationStatusMessage('', '');
      this.openModal('knife-registration-status');
    }

    setKnifeRegistrationStatusMessage(message, type) {
      const box = this.root.querySelector('[data-admin-knife-registration-status-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-admin__message is-${type}` : 'tkc-admin__message';
      box.textContent = message || '';
    }

    async saveKnifeRegistrationStatus(event) {
      event.preventDefault();

      const form = event.currentTarget;
      const id = form.elements.id.value;
      const button = form.querySelector('[data-admin-knife-registration-status-submit]');

      const input = {
        registration_status: form.elements.registration_status.value,
        admin_notes: form.elements.admin_notes ? (form.elements.admin_notes.value.trim() || null) : undefined
      };

      try {
        this.setKnifeRegistrationStatusMessage('', '');
        this.setButtonPending(button, true, 'Saving...');
        await this.api.updateKnifeRegistration(id, input);
        await this.refreshKnifeRegistrationsAfterChange();
        this.closeModals();
        this.setGlobalMessage('Registration status updated.', 'success');
      } catch (error) {
        this.setKnifeRegistrationStatusMessage(error.message || 'Status could not be updated.', 'error');
      } finally {
        this.setButtonPending(button, false);
      }
    }

    openKnifeRegistrationEditModal(registration) {
      const form = this.root.querySelector('[data-admin-knife-registration-form]');
      if (!form || !registration) return;

      form.reset();
      form.elements.id.value = registration.id || '';

      [
        'first_name', 'last_name', 'email', 'phone', 'address', 'knife_model', 'serial_number',
        'handle_material', 'blade_steel', 'order_number', 'purchase_location', 'purchase_location_other',
        'founders_run_number', 'certificate_number', 'box_number', 'customer_notes'
      ].forEach((field) => {
        if (form.elements[field]) form.elements[field].value = registration[field] == null ? '' : registration[field];
      });

      if (form.elements.purchase_date) form.elements.purchase_date.value = toDateInputValue(registration.purchase_date);

      this.knifeRegistrationPhotos = {
        knife_photo: { url: registration.knife_photo_url || '', action: null, file: null },
        certificate_photo: { url: registration.certificate_photo_url || '', action: null, file: null }
      };
      this.renderKnifeRegistrationPhotoField('knife_photo');
      this.renderKnifeRegistrationPhotoField('certificate_photo');

      this.syncKnifeRegistrationPurchaseLocation(form);

      this.setKnifeRegistrationMessage('', '');
      this.openModal('knife-registration');
    }

    syncKnifeRegistrationPurchaseLocation(form) {
      const field = this.root.querySelector('[data-admin-knife-registration-purchase-location-other]');
      if (!field || !form.elements.purchase_location) return;
      field.hidden = form.elements.purchase_location.value !== 'Other';
    }

    renderKnifeRegistrationPhotoField(key) {
      const container = this.root.querySelector(`[data-admin-knife-registration-photo="${key}"]`);
      if (!container) return;

      if (this.knifeRegistrationPhotoPreviewUrls[key]) {
        window.URL.revokeObjectURL(this.knifeRegistrationPhotoPreviewUrls[key]);
        delete this.knifeRegistrationPhotoPreviewUrls[key];
      }

      const state = this.knifeRegistrationPhotos[key] || {};

      if (state.file) {
        const url = window.URL.createObjectURL(state.file);
        this.knifeRegistrationPhotoPreviewUrls[key] = url;
        container.innerHTML = `
          <div class="tkc-admin__media-tile">
            <img src="${escapeHtml(url)}" alt="">
            <button class="tkc-admin__media-tile-remove" type="button" data-admin-knife-registration-remove-photo="${key}" aria-label="Remove selected photo">&times;</button>
          </div>
        `;
        return;
      }

      if (state.action === 'remove') {
        container.innerHTML = `
          <p class="tkc-admin__upload-note">
            Photo will be removed when you save.
            <button class="link" type="button" data-admin-knife-registration-undo-photo="${key}">Undo</button>
          </p>
        `;
        return;
      }

      if (state.url) {
        container.innerHTML = `
          <div class="tkc-admin__media-tile">
            <img src="${escapeHtml(state.url)}" alt="">
            <button class="tkc-admin__media-tile-remove" type="button" data-admin-knife-registration-remove-photo="${key}" aria-label="Remove photo">&times;</button>
          </div>
        `;
        return;
      }

      container.innerHTML = '<p class="tkc-admin__upload-note">No photo uploaded</p>';
    }

    handleKnifeRegistrationPhotoInput(event) {
      const input = event.target.closest('[data-admin-knife-registration-photo-input]');
      if (!input) return;

      const key = input.dataset.adminKnifeRegistrationPhotoInput;
      const file = input.files && input.files[0] ? input.files[0] : null;
      this.knifeRegistrationPhotos[key] = Object.assign({}, this.knifeRegistrationPhotos[key], { file, action: null });
      this.renderKnifeRegistrationPhotoField(key);
    }

    handleKnifeRegistrationPhotoAction(event) {
      const removeButton = event.target.closest('[data-admin-knife-registration-remove-photo]');
      const undoButton = event.target.closest('[data-admin-knife-registration-undo-photo]');

      if (removeButton) {
        const key = removeButton.dataset.adminKnifeRegistrationRemovePhoto;
        const state = this.knifeRegistrationPhotos[key] || {};
        const input = this.root.querySelector(`[data-admin-knife-registration-photo-input="${key}"]`);
        if (input) input.value = '';
        this.knifeRegistrationPhotos[key] = { url: state.url, file: null, action: state.url ? 'remove' : null };
        this.renderKnifeRegistrationPhotoField(key);
        return;
      }

      if (undoButton) {
        const key = undoButton.dataset.adminKnifeRegistrationUndoPhoto;
        const state = this.knifeRegistrationPhotos[key] || {};
        this.knifeRegistrationPhotos[key] = Object.assign({}, state, { action: null, file: null });
        this.renderKnifeRegistrationPhotoField(key);
      }
    }

    getKnifeRegistrationInput(form) {
      const val = (name) => (form.elements[name] ? form.elements[name].value.trim() : '');

      const input = {
        first_name: val('first_name'),
        last_name: val('last_name'),
        email: val('email'),
        phone: val('phone') || null,
        address: val('address') || null,
        knife_model: val('knife_model'),
        serial_number: val('serial_number') || null,
        handle_material: val('handle_material') || null,
        blade_steel: val('blade_steel') || null,
        purchase_date: val('purchase_date'),
        order_number: val('order_number') || null,
        purchase_location: val('purchase_location'),
        founders_run_number: val('founders_run_number') || null,
        certificate_number: val('certificate_number') || null,
        box_number: val('box_number') || null,
        customer_notes: val('customer_notes') || null
      };

      input.purchase_location_other = input.purchase_location === 'Other' ? (val('purchase_location_other') || null) : null;

      return input;
    }

    setKnifeRegistrationMessage(message, type) {
      const box = this.root.querySelector('[data-admin-knife-registration-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-admin__message is-${type}` : 'tkc-admin__message';
      box.textContent = message || '';
    }

    async submitKnifeRegistrationEdit(event) {
      event.preventDefault();
      const form = event.currentTarget;
      if (!form.reportValidity()) return;

      const button = form.querySelector('[data-admin-knife-registration-submit]');
      const id = form.elements.id.value;
      this.setKnifeRegistrationMessage('', '');

      const photoChanges = {};
      ['knife_photo', 'certificate_photo'].forEach((key) => {
        const state = this.knifeRegistrationPhotos[key] || {};
        if (state.file) photoChanges[key] = state.file;
        else if (state.action === 'remove') photoChanges[key] = 'remove';
      });

      try {
        this.setButtonPending(button, true, 'Saving...');
        await this.api.updateKnifeRegistration(id, this.getKnifeRegistrationInput(form), photoChanges);
        await this.refreshKnifeRegistrationsAfterChange();
        this.closeModals();
        this.setGlobalMessage('Registration updated.', 'success');
      } catch (error) {
        this.setKnifeRegistrationMessage(error.message || 'Registration could not be updated.', 'error');
      } finally {
        this.setButtonPending(button, false);
      }
    }

    openDeleteKnifeRegistrationModal(registration) {
      const form = this.root.querySelector('[data-admin-delete-knife-registration-form]');
      const title = this.root.querySelector('[data-admin-delete-knife-registration-title]');
      if (!form || !registration || !registration.id) return;

      this.pendingDeleteKnifeRegistrationId = registration.id;
      form.reset();
      form.elements.id.value = registration.id;
      if (title) title.textContent = registration.knife_model || 'this registration';
      this.setDeleteKnifeRegistrationMessage('', '');
      this.openModal('delete-knife-registration');
    }

    setDeleteKnifeRegistrationMessage(message, type) {
      const box = this.root.querySelector('[data-admin-delete-knife-registration-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-admin__message is-${type}` : 'tkc-admin__message';
      box.textContent = message || '';
    }

    async confirmDeleteKnifeRegistration(event) {
      event.preventDefault();

      const form = event.currentTarget;
      const id = form.elements.id.value || this.pendingDeleteKnifeRegistrationId;
      const button = form.querySelector('[data-admin-delete-knife-registration-submit]');

      if (!id) {
        this.setDeleteKnifeRegistrationMessage('Registration ID is missing.', 'error');
        return;
      }

      try {
        this.setDeleteKnifeRegistrationMessage('', '');
        this.setButtonPending(button, true, 'Deleting...');
        await this.api.deleteKnifeRegistration(id);
        this.pendingDeleteKnifeRegistrationId = null;
        this.closeModals();
        this.setGlobalMessage('Registration deleted.', 'success');

        // Step back a page if that was the last item on it, so we don't strand on a blank page.
        if (this.knifeRegistrations.length <= 1 && this.knifeRegistrationsPageIndex > 0) {
          this.knifeRegistrationsPageIndex -= 1;
        }
        await this.loadKnifeRegistrationsPage();
      } catch (error) {
        this.setDeleteKnifeRegistrationMessage(error.message || 'Registration could not be deleted.', 'error');
      } finally {
        this.setButtonPending(button, false);
      }
    }

    // Re-fetches the current page from the server (rather than patching the item in place) so the
    // list stays in sync with the active search/filters - e.g. an edit that changes a registration's
    // status should drop it off the page if it no longer matches a status filter that's applied.
    refreshKnifeRegistrationsAfterChange() {
      return this.loadKnifeRegistrationsPage();
    }

    findDrop(id) {
      return this.drops.find((drop) => drop && String(drop.id) === String(id)) || null;
    }

    handleDropAction(event) {
      const button = event.target.closest('[data-admin-drop-action]');
      if (!button || button.disabled) return;

      const drop = this.findDrop(button.dataset.adminDropId);
      if (!drop) return;

      if (button.dataset.adminDropAction === 'edit') {
        if (!isScheduledDrop(drop)) return;
        this.openDropModal(drop);
        return;
      }

      if (button.dataset.adminDropAction === 'cancel') {
        if (!isScheduledDrop(drop)) return;
        this.openCancelDropModal(drop);
        return;
      }

      if (button.dataset.adminDropAction === 'end') {
        this.openEndDropModal(drop);
      }
    }

    resetDropForm(form) {
      if (!form) return;

      form.reset();
      form.elements.id.value = '';
      form.elements.shopifyCollectionId.value = '';
      form.elements.timezone.value = 'America/Chicago';
      window.clearTimeout(this.dropCollectionSearchTimer);
      this.dropCollectionRequestId += 1;
      this.selectedDropCollection = null;
      this.renderDropCollectionResults([]);
    }

    openDropModal(drop) {
      const form = this.root.querySelector('[data-admin-drop-form]');
      const title = this.root.querySelector('[data-admin-drop-modal-title]');
      const submit = this.root.querySelector('[data-admin-drop-submit]');
      if (!form) return;
      if (drop && drop.id && !isScheduledDrop(drop)) return;

      this.resetDropForm(form);
      this.setDropMessage('', '');

      if (drop && drop.id) {
        const timezone = drop.timezone || 'America/Chicago';
        const parts = getZonedDateTimeParts(getDropLaunchAt(drop), timezone);
        form.elements.id.value = drop.id || '';
        form.elements.shopifyCollectionId.value = getDropCollectionId(drop);
        form.elements.collectionSearch.value = getDropCollectionTitle(drop);
        form.elements.launchDate.value = parts.date;
        form.elements.launchTime.value = parts.time;
        form.elements.timezone.value = timezone;
        form.elements.quantity.value = getDropQuantity(drop);
        form.elements.teaserDescription.value = getDropTeaser(drop);
        this.selectedDropCollection = {
          id: getDropCollectionId(drop),
          title: getDropCollectionTitle(drop),
          handle: getDropCollectionHandle(drop),
          productsCount: getDropProductsCount(drop)
        };
      }

      const isEditing = !!(drop && drop.id);

      if (title) title.textContent = isEditing ? 'Edit drop' : 'Create drop';
      if (submit) {
        submit.textContent = isEditing ? 'Save drop' : 'Create drop';
        submit.dataset.defaultText = submit.textContent;
      }
      this.openModal('drop');
    }

    setDropMessage(message, type) {
      const box = this.root.querySelector('[data-admin-drop-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-admin__message is-${type}` : 'tkc-admin__message';
      box.textContent = message || '';
    }

    queueDropCollectionSearch(query) {
      const form = this.root.querySelector('[data-admin-drop-form]');
      if (form && this.selectedDropCollection && query !== getCollectionTitle(this.selectedDropCollection)) {
        this.selectedDropCollection = null;
        form.elements.shopifyCollectionId.value = '';
      }

      this.renderDropCollectionResults([], String(query || '').trim() ? 'Searching collections...' : 'Loading collections...', 'loading');
      window.clearTimeout(this.dropCollectionSearchTimer);
      this.dropCollectionSearchTimer = window.setTimeout(() => this.searchDropCollections(query), 300);
    }

    openDropCollectionDropdown(options) {
      const opts = options || {};
      const form = this.root.querySelector('[data-admin-drop-form]');
      const container = this.root.querySelector('[data-admin-drop-collection-results]');
      const searchInput = form ? form.elements.collectionSearch : null;
      if (!container || !searchInput) return;

      searchInput.setAttribute('aria-expanded', 'true');

      if (container.innerHTML.trim()) {
        container.hidden = false;
        return;
      }

      if (opts.search === false) return;

      const selectedTitle = this.selectedDropCollection ? getCollectionTitle(this.selectedDropCollection) : '';
      const query = selectedTitle && searchInput.value === selectedTitle ? '' : searchInput.value;
      this.searchDropCollections(query);
    }

    closeDropCollectionDropdown() {
      const form = this.root.querySelector('[data-admin-drop-form]');
      const container = this.root.querySelector('[data-admin-drop-collection-results]');
      const searchInput = form ? form.elements.collectionSearch : null;

      if (container) container.hidden = true;
      if (searchInput) searchInput.setAttribute('aria-expanded', 'false');
    }

    isDropCollectionDropdownOpen() {
      const container = this.root.querySelector('[data-admin-drop-collection-results]');
      return !!(container && !container.hidden);
    }

    async searchDropCollections(query) {
      const search = String(query || '').trim();
      const requestId = ++this.dropCollectionRequestId;

      try {
        this.renderDropCollectionResults([], search ? 'Searching collections...' : 'Loading collections...', 'loading');
        const collections = await this.api.dropCollections(search);
        if (requestId !== this.dropCollectionRequestId) return;

        if (!collections.length) {
          this.renderDropCollectionResults([], search ? 'No matching collections found.' : 'No collections found.', 'empty');
          return;
        }

        this.renderDropCollectionResults(collections);
      } catch (error) {
        if (requestId !== this.dropCollectionRequestId) return;
        this.renderDropCollectionResults([], error.message || 'Collections could not be loaded.', 'error');
      }
    }

    renderDropCollectionResults(collections, message, type) {
      const container = this.root.querySelector('[data-admin-drop-collection-results]');
      if (!container) return;

      const form = this.root.querySelector('[data-admin-drop-form]');
      const searchInput = form ? form.elements.collectionSearch : null;
      const entries = Array.isArray(collections) ? collections : [];
      const hasContent = !!message || entries.length > 0;
      container.hidden = !hasContent;
      if (searchInput) searchInput.setAttribute('aria-expanded', hasContent ? 'true' : 'false');

      if (message) {
        container.innerHTML = `<div class="tkc-admin__state is-${escapeHtml(type || 'error')}">${escapeHtml(message)}</div>`;
        return;
      }

      container.innerHTML = entries.map((collection) => {
        const collectionId = getCollectionId(collection);
        const title = getCollectionTitle(collection);
        const handle = getCollectionHandle(collection);
        const productsCount = getCollectionProductCount(collection);
        const meta = [
          handle ? `/${handle}` : '',
          productsCount !== '' ? `${productsCount} product${Number(productsCount) === 1 ? '' : 's'}` : ''
        ].filter(Boolean).join(' - ');

        return `
          <button class="tkc-admin__collection-option" type="button" role="option" data-admin-drop-collection-option data-collection-id="${escapeHtml(collectionId)}" data-collection-title="${escapeHtml(title)}" data-collection-handle="${escapeHtml(handle)}" data-products-count="${escapeHtml(productsCount)}">
            <span>
              <strong>${escapeHtml(title)}</strong>
              ${meta ? `<span>${escapeHtml(meta)}</span>` : ''}
            </span>
          </button>
        `;
      }).join('');
    }

    handleDropCollectionSelection(event) {
      const button = event.target.closest('[data-admin-drop-collection-option]');
      if (!button) return;

      this.setDropCollection({
        id: button.dataset.collectionId || '',
        title: button.dataset.collectionTitle || '',
        handle: button.dataset.collectionHandle || '',
        productsCount: button.dataset.productsCount || ''
      });
    }

    setDropCollection(collection) {
      const form = this.root.querySelector('[data-admin-drop-form]');
      const results = this.root.querySelector('[data-admin-drop-collection-results]');
      if (!form || !collection || !collection.id) return;

      this.selectedDropCollection = collection;
      this.dropCollectionRequestId += 1;
      form.elements.shopifyCollectionId.value = collection.id;
      form.elements.collectionSearch.value = getCollectionTitle(collection);
      form.elements.collectionSearch.setCustomValidity('');

      if (results) {
        this.closeDropCollectionDropdown();
      }
    }

    getDropInput(form) {
      return {
        shopifyCollectionId: form.elements.shopifyCollectionId.value.trim(),
        launchDate: form.elements.launchDate.value,
        launchTime: form.elements.launchTime.value,
        timezone: form.elements.timezone.value.trim() || 'America/Chicago',
        quantity: Number(form.elements.quantity.value),
        teaserDescription: form.elements.teaserDescription.value.trim()
      };
    }

    async submitDrop(event) {
      event.preventDefault();

      const form = event.currentTarget;
      const collectionIdField = form.elements.shopifyCollectionId;
      const collectionSearch = form.elements.collectionSearch;
      preventLongDateYears(form);

      if (!collectionIdField.value) {
        collectionSearch.setCustomValidity('Select a collection from the search results.');
      } else {
        collectionSearch.setCustomValidity('');
      }

      if (!form.reportValidity()) return;

      const dropId = form.elements.id.value;
      const existingDrop = dropId ? this.findDrop(dropId) : null;

      if (dropId && existingDrop && !isScheduledDrop(existingDrop)) {
        this.setDropMessage('Only scheduled drops can be edited.', 'error');
        return;
      }

      const button = form.querySelector('[data-admin-drop-submit]');
      const input = this.getDropInput(form);

      try {
        this.setDropMessage('', '');
        this.setButtonPending(button, true, dropId ? 'Saving...' : 'Creating...');
        const saved = dropId ? await this.api.updateDrop(dropId, input) : await this.api.createDrop(input);

        if (saved && saved.id) {
          this.upsertDrop(saved);
        } else {
          await this.loadDrops();
        }

        this.closeModals();
        this.setGlobalMessage(dropId ? 'Drop updated.' : 'Drop created.', 'success');
        this.renderDrops();
        this.setState('drops', this.drops.length ? '' : 'empty', this.drops.length ? '' : 'No drops found.');
      } catch (error) {
        this.setDropMessage(error.message || 'Drop could not be saved.', 'error');
      } finally {
        this.setButtonPending(button, false);
      }
    }

    openCancelDropModal(drop) {
      const form = this.root.querySelector('[data-admin-cancel-drop-form]');
      const title = this.root.querySelector('[data-admin-cancel-drop-title]');
      if (!form || !drop || !drop.id || !isScheduledDrop(drop)) return;

      this.pendingCancelDropId = drop.id;
      form.reset();
      form.elements.id.value = drop.id;
      if (title) title.textContent = getDropCollectionTitle(drop);
      this.setCancelDropMessage('', '');
      this.openModal('cancel-drop');
    }

    setCancelDropMessage(message, type) {
      const box = this.root.querySelector('[data-admin-cancel-drop-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-admin__message is-${type}` : 'tkc-admin__message';
      box.textContent = message || '';
    }

    async confirmCancelDrop(event) {
      event.preventDefault();

      const form = event.currentTarget;
      const dropId = form.elements.id.value || this.pendingCancelDropId;
      const button = form.querySelector('[data-admin-cancel-drop-submit]');
      const drop = this.findDrop(dropId);

      if (!dropId) {
        this.setCancelDropMessage('Drop ID is missing.', 'error');
        return;
      }

      if (drop && !isScheduledDrop(drop)) {
        this.setCancelDropMessage('Only scheduled drops can be cancelled.', 'error');
        return;
      }

      await this.cancelDrop(dropId, drop, button);
    }

    async cancelDrop(dropId, drop, button) {
      const originalDrop = drop || this.findDrop(dropId);
      if (!dropId) return;

      try {
        this.setCancelDropMessage('', '');
        this.setButtonPending(button, true, 'Cancelling...');
        const cancelled = await this.api.cancelDrop(dropId);

        if (cancelled && cancelled.id) {
          this.upsertDrop(cancelled);
        } else if (originalDrop) {
          this.upsertDrop(Object.assign({}, originalDrop, { status: 'CANCELLED' }));
        }

        this.pendingCancelDropId = null;
        this.closeModals();
        this.renderDrops();
        this.setGlobalMessage('Drop cancelled.', 'success');
      } catch (error) {
        this.setCancelDropMessage(error.message || 'Drop could not be cancelled.', 'error');
      } finally {
        this.setButtonPending(button, false);
      }
    }

    openEndDropModal(drop) {
      const form = this.root.querySelector('[data-admin-end-drop-form]');
      const title = this.root.querySelector('[data-admin-end-drop-title]');
      if (!form || !drop || !drop.id || !isLiveDrop(drop)) return;

      this.pendingEndDropId = drop.id;
      form.reset();
      form.elements.id.value = drop.id;
      if (title) title.textContent = getDropCollectionTitle(drop);
      this.setEndDropMessage('', '');
      this.openModal('end-drop');
    }

    setEndDropMessage(message, type) {
      const box = this.root.querySelector('[data-admin-end-drop-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-admin__message is-${type}` : 'tkc-admin__message';
      box.textContent = message || '';
    }

    async confirmEndDrop(event) {
      event.preventDefault();

      const form = event.currentTarget;
      const dropId = form.elements.id.value || this.pendingEndDropId;
      const button = form.querySelector('[data-admin-end-drop-submit]');
      const drop = this.findDrop(dropId);

      if (!dropId) {
        this.setEndDropMessage('Drop ID is missing.', 'error');
        return;
      }

      if (drop && !isLiveDrop(drop)) {
        this.setEndDropMessage('Only live drops can be ended.', 'error');
        return;
      }

      await this.endDrop(dropId, drop, button);
    }

    async endDrop(dropId, drop, button) {
      const originalDrop = drop || this.findDrop(dropId);
      if (!dropId) return;

      try {
        this.setEndDropMessage('', '');
        this.setButtonPending(button, true, 'Ending...');
        const ended = await this.api.updateDrop(dropId, { status: 'ENDED' });

        if (ended && ended.id) {
          this.upsertDrop(Object.assign({}, originalDrop || {}, ended, { status: ended.status || 'ENDED' }));
        } else if (originalDrop) {
          this.upsertDrop(Object.assign({}, originalDrop, { status: 'ENDED' }));
        } else {
          await this.loadDrops();
        }

        this.pendingEndDropId = null;
        this.closeModals();
        this.renderDrops();
        this.setGlobalMessage('Drop ended.', 'success');
      } catch (error) {
        this.setEndDropMessage(error.message || 'Drop could not be ended.', 'error');
      } finally {
        this.setButtonPending(button, false);
      }
    }

    upsertDrop(drop) {
      if (!drop || !drop.id) return;

      const exists = this.drops.some((item) => String(item.id) === String(drop.id));
      this.drops = exists
        ? this.drops.map((item) => String(item.id) === String(drop.id) ? Object.assign({}, item, drop) : item)
        : [drop].concat(this.drops);
      this.loaded.drops = true;
    }

    async loadStories(forceRefresh, button) {
      this.stories = [];
      this.storiesPageInfo = {};
      this.storiesPage = 1;
      this.setState('stories', 'loading', 'Loading stories...');

      try {
        this.setButtonPending(button, true, 'Refreshing...');
        const stories = await this.fetchAllStories({ force: !!forceRefresh });
        const count = this.renderStories(stories);
        this.setState('stories', count ? '' : 'empty', count ? '' : 'No stories found.');
        this.loaded.stories = true;
      } catch (error) {
        this.showPanelError('stories', error);
      } finally {
        this.setButtonPending(button, false);
      }
    }

    async loadHallOfHonor() {
      this.setState('honor', 'loading', 'Loading Hall of Honor...');

      try {
        const stories = await this.fetchAllStories();
        this.honorPage = 1;
        const honorStories = this.renderHallOfHonor(stories);
        this.setState('honor', honorStories.length ? '' : 'empty', honorStories.length ? '' : 'No Hall of Honor stories found.');
        this.loaded.honor = true;
      } catch (error) {
        this.showPanelError('honor', error);
      }
    }

    renderHallOfHonor(stories) {
      const source = Array.isArray(stories) ? stories : this.allStories;
      const honorStories = source.filter(isHallOfHonor);
      const list = this.root.querySelector('[data-admin-honor-list]');
      const pageData = this.paginate(honorStories, this.honorPage);
      this.honorPage = pageData.currentPage;

      if (list) {
        list.innerHTML = pageData.items.length
          ? pageData.items.map((story) => this.renderStoryCard(story)).join('')
          : '<p class="tkc-admin__empty">No Hall of Honor stories found.</p>';
      }

      this.renderPagination('[data-admin-honor-pagination]', pageData, 'honor');
      return honorStories;
    }

    clearStoryFilters() {
      this.storyFilters = { search: '', status: '', featured: '', honor: '' };

      const search = this.root.querySelector('[data-admin-stories-search]');
      const status = this.root.querySelector('[data-admin-stories-status]');
      const featured = this.root.querySelector('[data-admin-stories-featured]');
      const honor = this.root.querySelector('[data-admin-stories-honor]');
      if (search) search.value = '';
      if (status) status.value = '';
      if (featured) featured.value = '';
      if (honor) honor.value = '';

      this.storiesPage = 1;
      const count = this.renderStories();
      this.setState('stories', count ? '' : 'empty', count ? '' : 'No stories found.');
    }

    paginate(items, page, overridePageSize) {
      const pageSize = Math.max(1, overridePageSize || this.storiesPerPage || 20);
      const totalItems = items.length;
      const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
      const currentPage = Math.min(Math.max(1, page || 1), totalPages);
      const start = (currentPage - 1) * pageSize;

      return {
        items: items.slice(start, start + pageSize),
        totalItems,
        totalPages,
        currentPage
      };
    }

    renderPagination(selector, pageData, type) {
      const container = this.root.querySelector(selector);
      if (!container) return;

      const shouldShow = pageData.totalItems > this.storiesPerPage;
      container.hidden = !shouldShow;

      if (!shouldShow) {
        container.innerHTML = '';
        return;
      }

      container.innerHTML = `
        <span class="tkc-admin__pagination-info">
          Page ${escapeHtml(pageData.currentPage)} of ${escapeHtml(pageData.totalPages)} - ${escapeHtml(pageData.totalItems)} stories
        </span>
        <button class="tkc-admin__pagination-btn" type="button" data-admin-page="${type}-prev" ${pageData.currentPage <= 1 ? 'disabled' : ''}>Previous</button>
        <button class="tkc-admin__pagination-btn" type="button" data-admin-page="${type}-next" ${pageData.currentPage >= pageData.totalPages ? 'disabled' : ''}>Next</button>
      `;
    }

    handlePagination(event, type) {
      const button = event.target.closest('[data-admin-page]');
      if (!button || button.disabled) return;

      if (type === 'stories') {
        this.storiesPage += button.dataset.adminPage.indexOf('next') !== -1 ? 1 : -1;
        this.renderStories();
        this.scrollToStoryRecords('stories');
        return;
      }

      this.honorPage += button.dataset.adminPage.indexOf('next') !== -1 ? 1 : -1;
      const honorStories = this.renderHallOfHonor();
      this.setState('honor', honorStories.length ? '' : 'empty', honorStories.length ? '' : 'No Hall of Honor stories found.');
      this.scrollToStoryRecords('honor');
    }

    scrollToStoryRecords(type) {
      const selector = type === 'honor' ? '[data-admin-honor-list]' : '[data-admin-stories-list]';
      const list = this.root.querySelector(selector);
      if (!list) return;

      window.requestAnimationFrame(() => {
        list.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    matchesStoryFilters(story) {
      if (this.storyFilters.status && normalizeStatus(story.status) !== normalizeStatus(this.storyFilters.status)) return false;
      if (this.storyFilters.featured === 'true' && !story.is_featured) return false;
      if (this.storyFilters.featured === 'false' && story.is_featured) return false;
      if (this.storyFilters.honor === 'true' && !isHallOfHonor(story)) return false;
      if (this.storyFilters.honor === 'false' && isHallOfHonor(story)) return false;

      const search = (this.storyFilters.search || '').trim().toLowerCase();
      if (!search) return true;

      const haystack = [
        story.title,
        story.description,
        story.display_name,
        story.email,
        story.country,
        story.harvested_species,
        story.harvest_type,
        story.model_name,
        story.city,
        story.state,
        story.status
      ].map((value) => String(value || '').toLowerCase()).join(' ');

      return haystack.indexOf(search) !== -1;
    }

    renderStories() {
      const list = this.root.querySelector('[data-admin-stories-list]');
      if (!list) return;

      const filtered = (this.allStories.length ? this.allStories : this.stories)
        .map(getStoryNode)
        .filter(Boolean)
        .filter((story) => this.matchesStoryFilters(story));
      const pageData = this.paginate(filtered, this.storiesPage);
      this.storiesPage = pageData.currentPage;

      list.innerHTML = pageData.items.length
        ? pageData.items.map((story) => this.renderStoryCard(story)).join('')
        : '<p class="tkc-admin__empty">No stories match your filters.</p>';

      this.renderPagination('[data-admin-stories-pagination]', pageData, 'stories');
      return filtered.length;
    }

    renderStoryCard(story) {
      const storyId = escapeHtml(story.id || '');
      const author = story.author ? story.author.name || story.author.email : '';
      const title = story.title || 'Untitled story';
      const editButton = `<button class="tkc-admin__icon-btn" type="button" data-admin-story-action="edit" data-admin-story-id="${storyId}" title="Edit story" aria-label="Edit story">${ICONS.edit}</button>`;
      const meta = [
        story.harvested_species || 'Species unavailable',
        story.model_name || 'Knife model unavailable',
        story.created_at ? formatDate(story.created_at) : 'Date unavailable'
      ];

      return `
        <article class="tkc-admin__record tkc-admin__story-card" data-admin-story-id="${storyId}">
          <button class="tkc-admin__story-card-media" type="button" data-admin-story-action="view" data-admin-story-id="${storyId}" aria-label="View ${escapeHtml(title)}">
            ${this.renderStoryCardMedia(story)}
          </button>
          <div class="tkc-admin__story-card-body">
            <div>
              <button class="tkc-admin__story-card-title" type="button" data-admin-story-action="view" data-admin-story-id="${storyId}">
                ${escapeHtml(title)}
              </button>
              <p class="tkc-admin__story-card-meta">${escapeHtml(author ? `By ${author}` : (story.display_name || 'Author unavailable'))}</p>
              <p class="tkc-admin__story-card-meta">${escapeHtml(meta.join(' - '))}</p>
            </div>

            <div class="tkc-admin__record-meta">
              <span class="tkc-admin__badge is-${escapeHtml(statusClass(story.status))}">${escapeHtml(story.status || 'Unknown')}</span>
              ${story.is_featured ? '<span class="tkc-admin__badge is-featured">Featured</span>' : ''}
              ${isHallOfHonor(story) ? '<span class="tkc-admin__badge is-honor">Hall of Honor</span>' : ''}
            </div>

            <div class="tkc-admin__record-actions">
              <button class="tkc-admin__action-btn is-status" type="button" data-admin-story-action="review" data-admin-story-id="${storyId}">Update Status</button>
              ${editButton}
              <button class="tkc-admin__icon-btn tkc-admin__icon-btn--danger" type="button" data-admin-story-action="delete" data-admin-story-id="${storyId}" title="Delete story" aria-label="Delete story">${ICONS.delete}</button>
            </div>
          </div>
        </article>
      `;
    }

    getStoryMediaItems(story) {
      return (story && Array.isArray(story.media) ? story.media : [])
        .filter((item) => item && item.url)
        .slice()
        .sort((a, b) => Number(a.sort_order || 0) - Number(b.sort_order || 0));
    }

    getPrimaryStoryMedia(story) {
      const media = this.getStoryMediaItems(story);
      return media.find((item) => normalizeStatus(item.media_type) !== 'VIDEO') || media[0] || null;
    }

    renderStoryCardMedia(story) {
      const item = this.getPrimaryStoryMedia(story);
      if (!item || !item.url) {
        return '<span class="tkc-admin__story-card-placeholder">No media added</span>';
      }

      const url = escapeHtml(item.url);
      if (normalizeStatus(item.media_type) === 'VIDEO') {
        return '<span class="tkc-admin__story-card-placeholder">Video story</span>';
      }

      return `<img class="tkc-admin__story-card-image" src="${url}" alt="${escapeHtml(story.title || 'Story media')}" loading="lazy">`;
    }

    renderMediaThumb(item) {
      if (!item || !item.url) return '';
      const url = escapeHtml(item.url);
      const type = normalizeStatus(item.media_type);

      if (type === 'VIDEO') {
        return '<span class="tkc-admin__media-thumb tkc-admin__media-thumb--video" aria-hidden="true">Play</span>';
      }

      return `<img class="tkc-admin__media-thumb" src="${url}" alt="">`;
    }

    findStory(id) {
      const candidates = []
        .concat(this.stories.map(getStoryNode).filter(Boolean))
        .concat(this.allStories);

      for (let index = 0; index < candidates.length; index += 1) {
        if (candidates[index] && String(candidates[index].id) === String(id)) return candidates[index];
      }

      return null;
    }

    handleStoryAction(event) {
      const button = event.target.closest('[data-admin-story-action]');
      if (!button) return;

      const story = this.findStory(button.dataset.adminStoryId);
      if (!story) return;

      if (button.dataset.adminStoryAction === 'view') {
        this.openStoryDetails(story);
        return;
      }

      if (button.dataset.adminStoryAction === 'review') {
        this.openReviewModal(story);
        return;
      }

      if (button.dataset.adminStoryAction === 'edit') {
        this.openEditStoryModal(story);
        return;
      }

      if (button.dataset.adminStoryAction === 'delete') {
        this.deleteStory(story);
        return;
      }

      if (button.dataset.adminStoryAction === 'approve') {
        this.openReviewModal(story, 'APPROVED');
        return;
      }

      if (button.dataset.adminStoryAction === 'needs-edits') {
        this.openReviewModal(story, 'NEEDS_EDITS');
        return;
      }

      if (button.dataset.adminStoryAction === 'reject') {
        this.openReviewModal(story, 'REJECTED');
        return;
      }

      if (button.dataset.adminStoryAction === 'feature') {
        this.quickUpdateStory(story, { is_featured: !story.is_featured }, story.is_featured ? 'Story removed from featured.' : 'Story marked as featured.', button);
        return;
      }

      if (button.dataset.adminStoryAction === 'honor') {
        this.quickUpdateStory(story, { is_hall_of_honour: !isHallOfHonor(story) }, isHallOfHonor(story) ? 'Story removed from Hall of Honor.' : 'Story marked as Hall of Honor.', button);
      }
    }

    deleteStory(story) {
      this.openDeleteStoryModal(story);
    }

    openDeleteStoryModal(story) {
      const form = this.root.querySelector('[data-admin-delete-story-form]');
      const title = this.root.querySelector('[data-admin-delete-story-title]');
      if (!form || !story || !story.id) return;

      this.pendingDeleteStoryId = story.id;
      form.reset();
      form.elements.id.value = story.id;
      if (title) title.textContent = story.title || story.country || 'this story';
      this.setDeleteStoryMessage('', '');
      this.openModal('delete-story');
    }

    setDeleteStoryMessage(message, type) {
      const box = this.root.querySelector('[data-admin-delete-story-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-admin__message is-${type}` : 'tkc-admin__message';
      box.textContent = message || '';
    }

    async confirmDeleteStory(event) {
      event.preventDefault();

      const form = event.currentTarget;
      const storyId = form.elements.id.value || this.pendingDeleteStoryId;
      const button = form.querySelector('[data-admin-delete-story-submit]');

      if (!storyId) {
        this.setDeleteStoryMessage('Story ID is missing.', 'error');
        return;
      }

      try {
        this.setDeleteStoryMessage('', '');
        this.setButtonPending(button, true, 'Deleting...');
        await this.api.deleteStory(storyId);
        this.pendingDeleteStoryId = null;
        this.removeStoryFromState(storyId);
        this.loaded.dashboard = false;
        this.loaded.honor = false;
        this.closeModals();
        this.setGlobalMessage('Story deleted.', 'success');
        this.refreshActiveStoryPanel();
      } catch (error) {
        this.setDeleteStoryMessage(error.message || 'Story could not be deleted.', 'error');
      } finally {
        this.setButtonPending(button, false);
      }
    }

    setButtonPending(button, pending, loadingText) {
      if (!button) return;

      if (!button.dataset.defaultText) {
        button.dataset.defaultText = button.textContent;
      }

      button.disabled = pending;
      button.textContent = pending ? (loadingText || 'Please wait...') : button.dataset.defaultText;
    }

    setReviewMessage(message, type) {
      const box = this.root.querySelector('[data-admin-review-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-admin__message is-${type}` : 'tkc-admin__message';
      box.textContent = message || '';
    }

    bindRemarksRequirement(form) {
      if (!form || !form.elements.status || !form.elements.reviewer_remarks) return;

      const sync = () => this.syncRemarksRequirement(form);
      form.elements.status.addEventListener('change', sync);
      form.elements.reviewer_remarks.addEventListener('input', sync);
      sync();
    }

    syncRemarksRequirement(form) {
      if (!form || !form.elements.status || !form.elements.reviewer_remarks) return true;

      const remarks = form.elements.reviewer_remarks;
      const required = isNeedsEditsStatus(form.elements.status.value);
      remarks.required = required;
      remarks.setAttribute('aria-required', required ? 'true' : 'false');

      if (required && !remarks.value.trim()) {
        remarks.setCustomValidity('Reviewer remarks are required when status is Needs Edits.');
        return false;
      }

      remarks.setCustomValidity('');
      return true;
    }

    openReviewModal(story, status) {
      const modal = this.root.querySelector('[data-admin-modal="review"]');
      const form = this.root.querySelector('[data-admin-review-form]');
      if (!modal || !form || !story) return;

      const title = modal.querySelector('[data-admin-review-title]');
      if (title) {
        title.textContent = `Update Status: ${story.title || 'Untitled story'}`;
      }

      form.reset();
      form.elements.id.value = story.id || '';
      const normalizedStatus = status || normalizeStatus(story.status);
      form.elements.status.value = ['PENDING', 'NEEDS_EDITS', 'APPROVED', 'REJECTED'].indexOf(normalizedStatus) !== -1 ? normalizedStatus : 'PENDING';
      form.elements.reviewer_remarks.value = story.reviewer_remarks || '';
      form.elements.is_featured.checked = !!story.is_featured;
      form.elements.is_hall_of_honour.checked = isHallOfHonor(story);
      this.syncRemarksRequirement(form);
      this.setReviewMessage('', '');
      this.openModal('review');
    }

    getReviewInput(form) {
      return {
        status: form.elements.status.value,
        reviewer_remarks: form.elements.reviewer_remarks.value.trim(),
        is_featured: form.elements.is_featured.checked,
        is_hall_of_honour: form.elements.is_hall_of_honour.checked
      };
    }

    async saveStoryReview(event) {
      event.preventDefault();

      const form = event.currentTarget;
      this.syncRemarksRequirement(form);
      if (!form.reportValidity()) return;

      const storyId = form.elements.id.value;
      const story = this.findStory(storyId);
      const button = form.querySelector('[data-admin-review-submit]');

      try {
        this.setReviewMessage('', '');
        this.setButtonPending(button, true, 'Saving...');
        await this.updateStory(story || { id: storyId }, this.getReviewInput(form), 'Story review saved.');
        this.closeModals();
      } catch (error) {
        this.setReviewMessage(error.message || 'Story review could not be saved.', 'error');
      } finally {
        this.setButtonPending(button, false);
      }
    }

    async quickUpdateStory(story, input, successMessage, button) {
      try {
        this.setGlobalMessage('', '');
        this.setButtonPending(button, true, 'Saving...');
        await this.updateStory(story, input, successMessage);
      } catch (error) {
        this.setGlobalMessage(error.message || 'Story could not be updated.', 'error');
      } finally {
        this.setButtonPending(button, false);
      }
    }

    async updateStory(story, input, successMessage, mediaItems) {
      if (!story || !story.id) {
        throw new Error('Story ID is missing.');
      }

      const updated = Array.isArray(mediaItems)
        ? await this.api.updateStory(story.id, input, mediaItems)
        : await this.api.updateStory(story.id, input);
      this.applyStoryUpdate(story.id, input, updated);
      this.loaded.dashboard = false;
      this.loaded.honor = false;

      if (this.activeTab === 'stories') {
        const count = this.renderStories();
        this.setState('stories', count ? '' : 'empty', count ? '' : 'No stories found.');
      } else if (this.activeTab === 'honor') {
        const honorStories = this.renderHallOfHonor();
        this.setState('honor', honorStories.length ? '' : 'empty', honorStories.length ? '' : 'No Hall of Honor stories found.');
      }

      this.setGlobalMessage(successMessage || 'Story updated.', 'success');
    }

    async openCreateStoryModal() {
      const form = this.root.querySelector('[data-admin-story-form]');
      if (!form) return;

      if (this.storyFormMode === 'edit' || this.editingStoryId) {
        this.editingStoryId = null;
        this.editingStoryMedia = [];
        this.storyDraftStarted = false;
      }

      this.setStoryFormMode('create');

      if (!this.storyDraftStarted) {
        this.resetStoryForm(form);
        this.clearNewMediaSelection();
        this.storyDraftStarted = true;
      }

      this.syncRemarksRequirement(form);
      this.setStoryMessage('', '');
      this.openModal('story');

      await this.loadCategories();

      const select = this.root.querySelector('[data-admin-story-category]');
      if (select && !select.value && select.dataset.defaultCategory) {
        select.value = select.dataset.defaultCategory;
      }
    }

    resetStoryForm(form) {
      if (!form) return;

      form.reset();
      this.syncSpeciesOtherField(form);
      if (form.elements.status) form.elements.status.value = 'APPROVED';
      if (form.elements.consent_age_confirmed) form.elements.consent_age_confirmed.checked = true;
      if (form.elements.category_id && form.elements.category_id.dataset.defaultCategory) {
        form.elements.category_id.value = form.elements.category_id.dataset.defaultCategory;
      }
    }

    async openEditStoryModal(story) {
      const form = this.root.querySelector('[data-admin-story-form]');
      if (!form || !story || !story.id) return;

      this.storyDraftStarted = false;
      this.editingStoryId = story.id;
      this.editingStoryMedia = this.getStoryMediaItems(story).slice();

      this.setStoryFormMode('edit');
      this.resetStoryForm(form);
      this.fillStoryForm(form, story);
      this.clearNewMediaSelection();
      this.syncRemarksRequirement(form);
      this.setStoryMessage('', '');
      this.openModal('story');

      await this.loadCategories();

      if (form.elements.category_id && story.category_id) {
        form.elements.category_id.value = story.category_id;
      }
    }

    setStoryFormMode(mode) {
      const isEdit = mode === 'edit';
      const modal = this.root.querySelector('[data-admin-modal="story"]');
      this.storyFormMode = isEdit ? 'edit' : 'create';
      if (!modal) return;

      const heading = modal.querySelector('.tkc-admin__modal-head h2');
      const submit = modal.querySelector('[data-admin-story-submit]');
      const submitText = isEdit ? 'Update story' : 'Create story';

      if (heading) heading.textContent = isEdit ? 'Edit story' : 'Create story';
      if (submit) {
        submit.textContent = submitText;
        submit.dataset.defaultText = submitText;
      }
    }

    fillStoryForm(form, story) {
      const setValue = (name, value) => {
        if (form.elements[name]) form.elements[name].value = value == null ? '' : value;
      };

      setValue('display_name', story.display_name);
      setValue('age', story.age);
      setValue('city', story.city);
      setValue('state', story.state);
      setValue('email', story.email);
      setValue('country', story.country);
      this.setSpeciesFormValue(form, story.harvested_species);
      setValue('harvest_type', story.harvest_type);
      setValue('harvest_season', story.harvest_season);
      setValue('harvest_date', toDateInputValue(story.harvest_date));
      setValue('title', story.title);
      setValue('description', story.description);
      setValue('model_name', story.model_name);
      setValue('category_id', story.category_id);
      setValue('reviewer_remarks', story.reviewer_remarks);

      if (form.elements.status) {
        const normalizedStatus = normalizeStatus(story.status);
        form.elements.status.value = ['PENDING', 'NEEDS_EDITS', 'APPROVED', 'REJECTED'].indexOf(normalizedStatus) !== -1 ? normalizedStatus : 'PENDING';
      }

      if (form.elements.is_featured) form.elements.is_featured.checked = !!story.is_featured;
      if (form.elements.is_hall_of_honour) form.elements.is_hall_of_honour.checked = isHallOfHonor(story);
      if (form.elements.consent_age_confirmed) form.elements.consent_age_confirmed.checked = !!story.consent_age_confirmed;
      if (form.elements.consent_guardian_confirmed) form.elements.consent_guardian_confirmed.checked = !!story.consent_guardian_confirmed;
      if (form.elements.media) form.elements.media.value = '';
      if (form.elements.video_url) form.elements.video_url.value = '';

      setPhoneFieldValue(form, story.phone || '');
    }

    setSpeciesFormValue(form, value) {
      const select = form ? form.elements.harvested_species : null;
      if (!select) return;

      const raw = value == null ? '' : String(value).trim();
      const match = raw
        ? Array.from(select.options).find((option) => option.value && option.value !== 'Other' && option.value.toLowerCase() === raw.toLowerCase())
        : null;

      if (!raw) {
        select.value = '';
      } else if (match) {
        select.value = match.value;
      } else {
        select.value = 'Other';
        if (form.elements.harvested_species_other) form.elements.harvested_species_other.value = raw;
      }

      this.syncSpeciesOtherField(form);
    }

    syncSpeciesOtherField(form) {
      const select = form ? form.elements.harvested_species : null;
      const field = form ? form.querySelector('[data-species-other-field]') : null;
      const input = form ? form.elements.harvested_species_other : null;
      if (!select || !field || !input) return;

      const isOther = select.value === 'Other';
      field.hidden = !isOther;
      input.required = isOther;
      if (!isOther) input.value = '';
    }

    getSpeciesInputValue(form) {
      const select = form.elements.harvested_species;
      if (!select) return '';

      const value = String(select.value || '').trim();
      if (value !== 'Other') return value;

      const other = form.elements.harvested_species_other;
      const otherValue = other ? other.value.trim() : '';
      return otherValue || value;
    }

    revokeNewMediaUrls() {
      this.storyNewMediaUrls.forEach((url) => window.URL.revokeObjectURL(url));
      this.storyNewMediaUrls = [];
    }

    clearNewMediaSelection() {
      this.revokeNewMediaUrls();
      this.selectedStoryFiles = [];

      const input = this.root.querySelector('[data-admin-story-form] input[name="media"]');
      if (input) input.value = '';

      this.renderNewMediaPreview();
    }

    handleNewMediaSelection(event) {
      this.revokeNewMediaUrls();
      this.selectedStoryFiles = Array.from(event.target.files || []);
      this.renderNewMediaPreview();
    }

    renderNewMediaPreview() {
      const container = this.root.querySelector('[data-admin-new-media-preview]');
      if (!container) return;

      this.revokeNewMediaUrls();

      if (!this.selectedStoryFiles.length) {
        container.hidden = true;
        container.innerHTML = '';
        return;
      }

      container.hidden = false;
      container.innerHTML = this.selectedStoryFiles.map((file, index) => {
        const isImage = file.type && file.type.indexOf('image/') === 0;
        const url = isImage ? window.URL.createObjectURL(file) : '';
        if (url) this.storyNewMediaUrls.push(url);

        const preview = url
          ? `<img src="${escapeHtml(url)}" alt="${escapeHtml(file.name || 'Selected image')}">`
          : `<span class="tkc-admin__media-tile-label">${escapeHtml(file.name || 'Selected media')}</span>`;

        return `
          <div class="tkc-admin__media-tile">
            ${preview}
            <button class="tkc-admin__media-tile-remove" type="button" data-admin-remove-new-media="${escapeHtml(index)}" aria-label="Remove selected media">&times;</button>
          </div>
        `;
      }).join('');
    }

    removeNewMedia(event) {
      const button = event.target.closest('[data-admin-remove-new-media]');
      if (!button) return;

      const index = Number(button.dataset.adminRemoveNewMedia);
      this.selectedStoryFiles = this.selectedStoryFiles.filter((file, fileIndex) => fileIndex !== index);

      const input = this.root.querySelector('[data-admin-story-form] input[name="media"]');
      if (input) input.value = '';

      this.renderNewMediaPreview();
    }

    setStoryMessage(message, type) {
      const box = this.root.querySelector('[data-admin-story-message]');
      if (!box) return;

      box.hidden = !message;
      box.className = type ? `tkc-admin__message is-${type}` : 'tkc-admin__message';
      box.textContent = message || '';
    }

    getStoryInput(form) {
      return {
        display_name: form.elements.display_name.value.trim(),
        age: Number(form.elements.age.value),
        city: form.elements.city.value.trim(),
        state: form.elements.state.value.trim(),
        email: form.elements.email.value.trim(),
        phone: getNormalizedPhoneNumber(form),
        country: form.elements.country.value.trim(),
        harvested_species: this.getSpeciesInputValue(form),
        harvest_type: form.elements.harvest_type.value.trim(),
        harvest_season: form.elements.harvest_season.value.trim(),
        harvest_date: form.elements.harvest_date.value,
        title: form.elements.title.value.trim(),
        description: form.elements.description.value.trim(),
        model_name: form.elements.model_name.value.trim(),
        category_id: form.elements.category_id.value.trim(),
        consent_age_confirmed: form.elements.consent_age_confirmed.checked,
        consent_age_text: this.config.ageConsentText || 'I confirm I am old enough to submit this story.',
        consent_guardian_confirmed: form.elements.consent_guardian_confirmed.checked,
        consent_guardian_text: this.config.guardianConsentText || 'I confirm that I have obtained parental or guardian consent for this submission, or I am the parent/guardian submitting on behalf of a minor.'
      };
    }

    getStoryReviewInputFromForm(form) {
      return {
        status: form.elements.status.value,
        reviewer_remarks: form.elements.reviewer_remarks.value.trim(),
        is_featured: form.elements.is_featured.checked,
        is_hall_of_honour: form.elements.is_hall_of_honour.checked
      };
    }

    getStoryUpdateMedia(form) {
      const media = [];

      (this.editingStoryMedia || []).forEach((item) => {
        if (!item) return;

        if (item.id) {
          media.push({ id: item.id });
          return;
        }

        if (item.url) {
          media.push({
            url: item.url,
            media_type: item.media_type || 'IMAGE'
          });
        }
      });

      this.selectedStoryFiles.forEach((file) => media.push(file));

      const videoUrl = form.elements.video_url ? form.elements.video_url.value.trim() : '';
      if (videoUrl) {
        media.push({ url: videoUrl, media_type: 'VIDEO' });
      }

      return media;
    }

    async submitStory(event) {
      event.preventDefault();

      const form = event.currentTarget;
      this.syncRemarksRequirement(form);
      validatePhoneField(form, { required: false });
      preventLongDateYears(form);
      if (!form.reportValidity()) return;

      const button = form.querySelector('[data-admin-story-submit]');
      const isEdit = !!this.editingStoryId;
      const media = [];
      this.selectedStoryFiles.forEach((file) => media.push(file));

      const videoUrl = form.elements.video_url ? form.elements.video_url.value.trim() : '';
      if (videoUrl) {
        media.push({ url: videoUrl, media_type: 'VIDEO' });
      }

      try {
        this.setStoryMessage('', '');
        this.setButtonPending(button, true, isEdit ? 'Updating...' : 'Creating...');

        if (isEdit) {
          const story = this.findStory(this.editingStoryId) || { id: this.editingStoryId };
          const input = Object.assign({}, this.getStoryInput(form), this.getStoryReviewInputFromForm(form));
          await this.updateStory(story, input, 'Story updated.', this.getStoryUpdateMedia(form));

          this.editingStoryId = null;
          this.editingStoryMedia = [];
          this.honorPage = 1;
          this.resetStoryForm(form);
          this.clearNewMediaSelection();
          this.setStoryFormMode('create');
          this.storyDraftStarted = false;
          this.closeModals();
          return;
        }

        const created = await this.api.createStory(this.getStoryInput(form), media);
        const reviewInput = this.getStoryReviewInputFromForm(form);
        let finalStory = created;

        if (created && created.id) {
          const reviewed = await this.api.updateStory(created.id, reviewInput);
          finalStory = Object.assign({}, created, reviewInput, reviewed || {});
        }

        if (finalStory && finalStory.id) {
          this.addStoryToState(finalStory);
        } else {
          await this.fetchAllStories();
        }

        this.storiesPage = 1;
        this.honorPage = 1;
        this.loaded.dashboard = false;
        this.loaded.stories = true;
        this.loaded.honor = false;
        this.resetStoryForm(form);
        this.clearNewMediaSelection();
        this.storyDraftStarted = false;
        this.closeModals();
        this.setGlobalMessage('Story created.', 'success');

        if (this.activeTab === 'stories') {
          const count = this.renderStories();
          this.setState('stories', count ? '' : 'empty', count ? '' : 'No stories found.');
        } else if (this.activeTab === 'honor') {
          const honorStories = this.renderHallOfHonor();
          this.setState('honor', honorStories.length ? '' : 'empty', honorStories.length ? '' : 'No Hall of Honor stories found.');
        }
      } catch (error) {
        this.setStoryMessage(error.message || (isEdit ? 'Story could not be updated.' : 'Story could not be created.'), 'error');
      } finally {
        this.setButtonPending(button, false);
      }
    }

    addStoryToState(story) {
      if (!story || !story.id) return;

      const exists = this.allStories.some((item) => String(item.id) === String(story.id));
      if (exists) {
        this.allStories = this.allStories.map((item) => String(item.id) === String(story.id) ? story : item);
      } else {
        this.allStories = [story].concat(this.allStories);
      }

      this.stories = this.allStories;
      this.storiesFetchedAt = Date.now();
      this.persistStoriesCache();
    }

    async loadCategories() {
      const select = this.root.querySelector('[data-admin-story-category]');
      if (!select || this.loaded.categories) return;

      try {
        const categories = await this.api.categories();
        this.categories = categories;
        this.populateCategories(select, categories);
        this.loaded.categories = true;
      } catch (error) {
        if (select.dataset.defaultCategory) {
          select.innerHTML = `<option value="${escapeHtml(select.dataset.defaultCategory)}">${escapeHtml(select.dataset.defaultCategory)}</option>`;
          select.value = select.dataset.defaultCategory;
        }

        this.setStoryMessage(error.message || 'Categories could not be loaded.', 'error');
      }
    }

    populateCategories(select, categories) {
      const preferred = select.value || select.dataset.defaultCategory || this.config.defaultCategoryId || '';
      const sorted = (categories || []).slice().sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
      const options = sorted.map((category) =>
        `<option value="${escapeHtml(category.id)}">${escapeHtml(category.label || category.slug || category.id)}</option>`
      ).join('');

      select.innerHTML = `<option value="">Select a category</option>${options}`;

      if (preferred && sorted.some((category) => category.id === preferred)) {
        select.value = preferred;
      }
    }

    applyStoryUpdate(storyId, input, updated) {
      const returnedStory = getStoryNode(updated) || {};
      const patch = Object.assign({}, input || {}, returnedStory);

      if (Object.prototype.hasOwnProperty.call(patch, 'is_hall_of_honour')) {
        patch.is_hall_of_honor = patch.is_hall_of_honour;
      }

      const mergeStory = (story) => {
        if (!story || String(story.id) !== String(storyId)) return story;
        return Object.assign({}, story, patch);
      };

      this.stories = this.stories.map((edge) => {
        const node = getStoryNode(edge);
        if (!node || String(node.id) !== String(storyId)) return edge;
        const merged = mergeStory(node);
        return edge && edge.node ? Object.assign({}, edge, { node: merged }) : merged;
      });

      this.allStories = this.allStories.map(mergeStory);
      this.storiesFetchedAt = Date.now();
      this.persistStoriesCache();
    }

    removeStoryFromState(storyId) {
      const keepStory = (item) => {
        const node = getStoryNode(item);
        return !node || String(node.id) !== String(storyId);
      };

      this.stories = this.stories.filter(keepStory);
      this.allStories = this.allStories.filter(keepStory);
      this.storiesFetchedAt = Date.now();
      this.persistStoriesCache();
    }

    refreshActiveStoryPanel() {
      if (this.activeTab === 'stories') {
        const count = this.renderStories();
        this.setState('stories', count ? '' : 'empty', count ? '' : 'No stories found.');
        return;
      }

      if (this.activeTab === 'honor') {
        const honorStories = this.renderHallOfHonor();
        this.setState('honor', honorStories.length ? '' : 'empty', honorStories.length ? '' : 'No Hall of Honor stories found.');
      }
    }

    openStoryDetails(story) {
      const container = this.root.querySelector('[data-admin-story-details]');
      if (!container) return;

      container.innerHTML = this.renderStoryDetails(story);
      this.openModal('story-details');
    }

    renderStoryGalleryMain(item, story) {
      if (!item || !item.url) {
        return '<div class="tkc-admin__story-view-main is-empty">No media added</div>';
      }

      const url = escapeHtml(item.url);
      const isVideo = normalizeStatus(item.media_type) === 'VIDEO';
      const type = isVideo ? 'video' : 'image';
      const label = isVideo ? 'Open video preview' : 'Open image preview';
      const content = isVideo
        ? renderVideoPreview(item.url, 'tkc-admin__story-view-media-file')
        : `<img class="tkc-admin__story-view-media-file" src="${url}" alt="${escapeHtml(story.title || 'Story media')}" loading="eager">`;

      return `
        <button class="tkc-admin__story-view-main" type="button" data-admin-story-gallery-main data-admin-media-lightbox data-media-type="${type}" data-media-url="${url}" aria-label="${label}">
          ${content}
        </button>
      `;
    }

    renderStoryGalleryThumb(item, story, index) {
      if (!item || !item.url) return '';
      const url = escapeHtml(item.url);
      const isVideo = normalizeStatus(item.media_type) === 'VIDEO';
      const type = isVideo ? 'video' : 'image';
      const content = isVideo
        ? '<span class="tkc-admin__story-view-thumb-video">Video</span>'
        : `<img src="${url}" alt="${escapeHtml(story.title || 'Story media')} thumbnail" loading="lazy">`;

      return `
        <button class="tkc-admin__story-view-thumb${index === 0 ? ' is-active' : ''}" type="button" data-admin-story-gallery-thumb data-media-type="${type}" data-media-url="${url}" aria-label="Show media ${index + 1}"${index === 0 ? ' aria-current="true"' : ''}>
          ${content}
        </button>
      `;
    }

    setStoryGalleryMedia(button) {
      const gallery = button.closest('[data-admin-story-gallery]');
      if (!gallery) return;

      const main = gallery.querySelector('[data-admin-story-gallery-main]');
      const url = button.dataset.mediaUrl || '';
      const type = button.dataset.mediaType || 'image';
      if (!main || !url) return;

      main.dataset.mediaUrl = url;
      main.dataset.mediaType = type;
      main.setAttribute('aria-label', type === 'video' ? 'Open video preview' : 'Open image preview');
      main.innerHTML = type === 'video'
        ? renderVideoPreview(url, 'tkc-admin__story-view-media-file')
        : `<img class="tkc-admin__story-view-media-file" src="${escapeHtml(url)}" alt="Story media" loading="eager">`;

      gallery.querySelectorAll('[data-admin-story-gallery-thumb]').forEach((thumb) => {
        const isActive = thumb === button;
        thumb.classList.toggle('is-active', isActive);
        if (isActive) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    renderStoryDescription(description) {
      const text = String(description || '').trim();
      if (!text) return '<p>No story description has been added yet.</p>';

      return text.split(/\n{2,}/).map((paragraph) => `<p>${escapeHtml(paragraph)}</p>`).join('');
    }

    renderStoryDetails(story) {
      const category = story.category ? story.category.label || story.category.slug || '' : '';
      const author = story.author ? story.author.name || story.author.email || '' : '';
      const location = [story.city, story.state].filter(Boolean).join(', ');
      const title = story.title || story.country || 'Untitled story';
      const subtitle = [
        story.display_name || author,
        story.harvested_species,
        location,
        story.harvest_date ? formatDate(story.harvest_date) : ''
      ].filter(Boolean).join(' | ');
      const media = this.getStoryMediaItems(story);
      const primaryMedia = this.getPrimaryStoryMedia(story);
      const rows = [
        ['Hunter', story.display_name || author],
        ['Story title', title],
        ['Country', story.country],
        ['Species', story.harvested_species],
        ['Harvest type', story.harvest_type],
        ['Knife model', story.model_name],
        ['Location', location],
        ['Category', category],
        ['Status', story.status],
        ['Featured', story.is_featured ? 'Yes' : 'No'],
        ['Hall of Honor', isHallOfHonor(story) ? 'Yes' : 'No'],
        ['City', story.city],
        ['State', story.state],
        ['Harvest season', story.harvest_season],
        ['Harvest date', story.harvest_date ? formatDate(story.harvest_date) : ''],
        ['Author', author],
        ['Age', story.age],
        ['Age bracket', story.age_bracket],
        ['Email', story.email],
        ['Phone', story.phone],
        ['Created', formatDate(story.created_at)],
        ['Updated', formatDate(story.updated_at)],
        ['Published', story.published_at ? formatDate(story.published_at) : ''],
        ['Reviewer remarks', story.reviewer_remarks]
      ];

      const detailRows = rows
        .filter((row) => row[1] !== null && row[1] !== undefined && row[1] !== '')
        .map((row) => `
          <div class="tkc-admin__detail-row">
            <dt>${escapeHtml(row[0])}</dt>
            <dd>${escapeHtml(String(row[1]))}</dd>
          </div>
        `).join('');

      const thumbs = media.length > 1
        ? `<div class="tkc-admin__story-view-thumbs">${media.map((item, index) => this.renderStoryGalleryThumb(item, story, index)).join('')}</div>`
        : '';

      return `
        <div class="tkc-admin__story-view" data-admin-story-gallery>
          <div class="tkc-admin__story-view-media">
            ${this.renderStoryGalleryMain(primaryMedia, story)}
            ${thumbs}
          </div>
          <div class="tkc-admin__story-view-content">
            <p class="tkc-admin__story-view-kicker">${escapeHtml(isHallOfHonor(story) ? 'Hall of Honor' : 'TKC Story')}</p>
            <h3 class="tkc-admin__detail-title">${escapeHtml(title)}</h3>
            ${subtitle ? `<p class="tkc-admin__story-view-subtitle">${escapeHtml(subtitle)}</p>` : ''}
            <div class="tkc-admin__detail-description">${this.renderStoryDescription(story.description)}</div>
            <dl class="tkc-admin__detail-list">${detailRows}</dl>
          </div>
        </div>
      `;
    }

    renderMedia(item) {
      if (!item || !item.url) return '';
      const url = escapeHtml(item.url);
      const type = normalizeStatus(item.media_type) === 'VIDEO' ? 'video' : 'image';

      if (type === 'video') {
        return `
          <button class="tkc-admin__media-btn" type="button" data-admin-media-lightbox data-media-type="video" data-media-url="${url}" aria-label="Open video preview">
            <span class="tkc-admin__media tkc-admin__media--video">Play video</span>
          </button>
        `;
      }

      return `
        <button class="tkc-admin__media-btn" type="button" data-admin-media-lightbox data-media-type="image" data-media-url="${url}" aria-label="Open image preview">
          <img class="tkc-admin__media" src="${url}" alt="" loading="lazy">
        </button>
      `;
    }

    isMediaLightboxOpen() {
      const lightbox = this.root.querySelector('[data-admin-lightbox]');
      return !!(lightbox && !lightbox.hidden);
    }

    openMediaLightbox(button) {
      if (!button) return;

      const lightbox = this.root.querySelector('[data-admin-lightbox]');
      const body = this.root.querySelector('[data-admin-lightbox-body]');
      if (!lightbox || !body) return;

      const url = button.dataset.mediaUrl || '';
      const type = button.dataset.mediaType || 'image';
      if (!url) return;

      body.innerHTML = type === 'video'
        ? renderVideoPlayer(url, 'tkc-admin__lightbox-video', true)
        : `<img src="${escapeHtml(url)}" alt="">`;
      lightbox.hidden = false;

      const close = lightbox.querySelector('[data-admin-lightbox-close]');
      if (close) close.focus();
    }

    closeMediaLightbox() {
      const lightbox = this.root.querySelector('[data-admin-lightbox]');
      const body = this.root.querySelector('[data-admin-lightbox-body]');
      if (!lightbox) return;

      lightbox.hidden = true;
      if (body) body.innerHTML = '';
    }

    getStoredUser() {
      const keys = unique([this.userKey, 'tkcAdminUser']);

      for (let index = 0; index < keys.length; index += 1) {
        const raw = window.localStorage.getItem(keys[index]);
        if (!raw) continue;

        try {
          const parsed = JSON.parse(raw);
          if (parsed && typeof parsed === 'object') return parsed;
        } catch (error) {
          // Ignore malformed stored user.
        }
      }

      return {};
    }

    loadProfile() {
      const container = this.root.querySelector('[data-admin-profile]');
      if (!container) return;

      const user = this.getStoredUser();
      const rows = [
        ['Name', user.name],
        ['Email', user.email],
        ['Role', user.role]
      ].filter((row) => row[1] !== null && row[1] !== undefined && row[1] !== '');

      container.innerHTML = rows.length
        ? `<dl class="tkc-admin__detail-list">${rows.map((row) => `
            <div class="tkc-admin__detail-row">
              <dt>${escapeHtml(row[0])}</dt>
              <dd>${escapeHtml(String(row[1]))}</dd>
            </div>
          `).join('')}</dl>`
        : '<p class="tkc-admin__empty">No admin profile details available.</p>';

      this.loaded.profile = true;
    }

    getDeviceId() {
      const keys = unique([this.deviceIdKey, 'device_id', 'deviceId', 'tkcDeviceId', 'tkc_device_id']);

      for (let index = 0; index < keys.length; index += 1) {
        const value = window.localStorage.getItem(keys[index]);
        if (value) return value;
      }

      return '';
    }

    clearSession() {
      unique([
        this.config.tokenKey || 'tkcAdminAccessToken',
        ...(Array.isArray(this.config.tokenFallbackKeys) ? this.config.tokenFallbackKeys : []),
        'tkcAdminAccessToken',
        'adminAccessToken',
        'tkcAdminToken'
      ]).forEach((key) => window.localStorage.removeItem(key));

      window.localStorage.removeItem(this.userKey);
      window.localStorage.removeItem('tkcAdminUser');
      window.localStorage.removeItem(this.loginAtKey);
      window.localStorage.removeItem(this.storyCooldownKey);

      try {
        window.sessionStorage.removeItem(this.storyCacheKey);
      } catch (error) {
        // Ignore storage failures during logout.
      }
    }

    getLoginUrl() {
      return this.config.loginUrl || '/pages/admin-login';
    }

    redirectToLogin() {
      window.location.href = this.getLoginUrl();
    }

    async logout(event) {
      event.preventDefault();

      const button = event.currentTarget;
      const loginUrl = this.getLoginUrl();
      const deviceId = this.getDeviceId();

      try {
        button.disabled = true;

        if (deviceId && this.api.getToken()) {
          await this.api.signout(deviceId);
        }
      } catch (error) {
        window.console.warn('Admin portal signout failed before local logout.', error);
      } finally {
        this.clearSession();
        window.location.href = loginUrl;
      }
    }

    openModal(name) {
      const modal = this.root.querySelector(`[data-admin-modal="${name}"]`);
      if (!modal) return;

      modal.hidden = false;
      modal.classList.add('is-open');

      const focusable = modal.querySelector('input:not([type="hidden"]), select, textarea, button');
      if (focusable) focusable.focus();
    }

    closeModals() {
      this.closeDropCollectionDropdown();
      this.root.querySelectorAll('[data-admin-modal]').forEach((modal) => {
        modal.hidden = true;
        modal.classList.remove('is-open');
      });
    }
  }

  onReady(() => {
    if (!window.TKC || !window.TKC.AdminPortalApi) return;

    document.querySelectorAll('[data-admin-portal]').forEach((root) => {
      if (root.dataset.adminPortalBound === 'true') return;
      root.dataset.adminPortalBound = 'true';
      new AdminPortal(root);
    });
  });
})();
